/*Zepto v1.1.4  zeptojs.com/license */
var Zepto = function() {
    function a(a) { return null == a ? String(a) : W[X.call(a)] || "object" }

    function b(b) { return "function" == a(b) }

    function c(a) { return null != a && a == a.window }

    function d(a) { return null != a && a.nodeType == a.DOCUMENT_NODE }

    function e(b) { return "object" == a(b) }

    function f(a) { return e(a) && !c(a) && Object.getPrototypeOf(a) == Object.prototype }

    function g(a) { return "number" == typeof a.length }

    function h(a) { return E.call(a, function(a) { return null != a }) }

    function i(a) { return a.length > 0 ? y.fn.concat.apply([], a) : a }

    function j(a) { return a.replace(/::/g, "/").replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").replace(/_/g, "-").toLowerCase() }

    function k(a) { return a in I ? I[a] : I[a] = new RegExp("(^|\\s)" + a + "(\\s|$)") }

    function l(a, b) { return "number" != typeof b || J[j(a)] ? b : b + "px" }

    function m(a) { var b, c; return H[a] || (b = G.createElement(a), G.body.appendChild(b), c = getComputedStyle(b, "").getPropertyValue("display"), b.parentNode.removeChild(b), "none" == c && (c = "block"), H[a] = c), H[a] }

    function n(a) { return "children" in a ? F.call(a.children) : y.map(a.childNodes, function(a) { return 1 == a.nodeType ? a : void 0 }) }

    function o(a, b) {
        var c, d = a ? a.length : 0;
        for (c = 0; d > c; c++) this[c] = a[c];
        this.length = d, this.selector = b || ""
    }

    function p(a, b, c) { for (x in b) c && (f(b[x]) || _(b[x])) ? (f(b[x]) && !f(a[x]) && (a[x] = {}), _(b[x]) && !_(a[x]) && (a[x] = []), p(a[x], b[x], c)) : b[x] !== w && (a[x] = b[x]) }

    function q(a, b) { return null == b ? y(a) : y(a).filter(b) }

    function r(a, c, d, e) { return b(c) ? c.call(a, d, e) : c }

    function s(a, b, c) { null == c ? a.removeAttribute(b) : a.setAttribute(b, c) }

    function t(a, b) {
        var c = a.className || "",
            d = c && c.baseVal !== w;
        return b === w ? d ? c.baseVal : c : void(d ? c.baseVal = b : a.className = b)
    }

    function u(a) { try { return a ? "true" == a || ("false" == a ? !1 : "null" == a ? null : +a + "" == a ? +a : /^[\[\{]/.test(a) ? y.parseJSON(a) : a) : a } catch (b) { return a } }

    function v(a, b) { b(a); for (var c = 0, d = a.childNodes.length; d > c; c++) v(a.childNodes[c], b) }
    var w, x, y, z, A, B, C = [],
        D = C.concat,
        E = C.filter,
        F = C.slice,
        G = window.document,
        H = {},
        I = {},
        J = { "column-count": 1, columns: 1, "font-weight": 1, "line-height": 1, opacity: 1, "z-index": 1, zoom: 1 },
        K = /^\s*<(\w+|!)[^>]*>/,
        L = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
        M = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
        N = /^(?:body|html)$/i,
        O = /([A-Z])/g,
        P = ["val", "css", "html", "text", "data", "width", "height", "offset"],
        Q = ["after", "prepend", "before", "append"],
        R = G.createElement("table"),
        S = G.createElement("tr"),
        T = { tr: G.createElement("tbody"), tbody: R, thead: R, tfoot: R, td: S, th: S, "*": G.createElement("div") },
        U = /complete|loaded|interactive/,
        V = /^[\w-]*$/,
        W = {},
        X = W.toString,
        Y = {},
        Z = G.createElement("div"),
        $ = { tabindex: "tabIndex", readonly: "readOnly", "for": "htmlFor", "class": "className", maxlength: "maxLength", cellspacing: "cellSpacing", cellpadding: "cellPadding", rowspan: "rowSpan", colspan: "colSpan", usemap: "useMap", frameborder: "frameBorder", contenteditable: "contentEditable" },
        _ = Array.isArray || function(a) { return a instanceof Array };
    return Y.matches = function(a, b) {
        if (!b || !a || 1 !== a.nodeType) return !1;
        var c = a.webkitMatchesSelector || a.mozMatchesSelector || a.oMatchesSelector || a.matchesSelector;
        if (c) return c.call(a, b);
        var d, e = a.parentNode,
            f = !e;
        return f && (e = Z).appendChild(a), d = ~Y.qsa(e, b).indexOf(a), f && Z.removeChild(a), d
    }, A = function(a) { return a.replace(/-+(.)?/g, function(a, b) { return b ? b.toUpperCase() : "" }) }, B = function(a) { return E.call(a, function(b, c) { return a.indexOf(b) == c }) }, Y.fragment = function(a, b, c) { var d, e, g; return L.test(a) && (d = y(G.createElement(RegExp.$1))), d || (a.replace && (a = a.replace(M, "<$1></$2>")), b === w && (b = K.test(a) && RegExp.$1), b in T || (b = "*"), g = T[b], g.innerHTML = "" + a, d = y.each(F.call(g.childNodes), function() { g.removeChild(this) })), f(c) && (e = y(d), y.each(c, function(a, b) { P.indexOf(a) > -1 ? e[a](b) : e.attr(a, b) })), d }, Y.Z = function(a, b) { return new o(a, b) }, Y.isZ = function(a) { return a instanceof Y.Z }, Y.init = function(a, c) {
        var d;
        if (!a) return Y.Z();
        if ("string" == typeof a)
            if (a = a.trim(), "<" == a[0] && K.test(a)) d = Y.fragment(a, RegExp.$1, c), a = null;
            else {
                if (c !== w) return y(c).find(a);
                d = Y.qsa(G, a)
            }
        else {
            if (b(a)) return y(G).ready(a);
            if (Y.isZ(a)) return a;
            if (_(a)) d = h(a);
            else if (e(a)) d = [a], a = null;
            else if (K.test(a)) d = Y.fragment(a.trim(), RegExp.$1, c), a = null;
            else {
                if (c !== w) return y(c).find(a);
                d = Y.qsa(G, a)
            }
        }
        return Y.Z(d, a)
    }, y = function(a, b) { return Y.init(a, b) }, y.extend = function(a) { var b, c = F.call(arguments, 1); return "boolean" == typeof a && (b = a, a = c.shift()), c.forEach(function(c) { p(a, c, b) }), a }, Y.qsa = function(a, b) {
        var c, d = "#" == b[0],
            e = !d && "." == b[0],
            f = d || e ? b.slice(1) : b,
            g = V.test(f);
        return a.getElementById && g && d ? (c = a.getElementById(f)) ? [c] : [] : 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType ? [] : F.call(g && !d && a.getElementsByClassName ? e ? a.getElementsByClassName(f) : a.getElementsByTagName(b) : a.querySelectorAll(b))
    }, y.contains = G.documentElement.contains ? function(a, b) { return a !== b && a.contains(b) } : function(a, b) {
        for (; b && (b = b.parentNode);)
            if (b === a) return !0;
        return !1
    }, y.type = a, y.isFunction = b, y.isWindow = c, y.isArray = _, y.isPlainObject = f, y.isEmptyObject = function(a) { var b; for (b in a) return !1; return !0 }, y.inArray = function(a, b, c) { return C.indexOf.call(b, a, c) }, y.camelCase = A, y.trim = function(a) { return null == a ? "" : String.prototype.trim.call(a) }, y.uuid = 0, y.support = {}, y.expr = {}, y.noop = function() {}, y.map = function(a, b) {
        var c, d, e, f = [];
        if (g(a))
            for (d = 0; d < a.length; d++) c = b(a[d], d), null != c && f.push(c);
        else
            for (e in a) c = b(a[e], e), null != c && f.push(c);
        return i(f)
    }, y.each = function(a, b) {
        var c, d;
        if (g(a)) {
            for (c = 0; c < a.length; c++)
                if (b.call(a[c], c, a[c]) === !1) return a
        } else
            for (d in a)
                if (b.call(a[d], d, a[d]) === !1) return a; return a
    }, y.grep = function(a, b) { return E.call(a, b) }, window.JSON && (y.parseJSON = JSON.parse), y.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(a, b) { W["[object " + b + "]"] = b.toLowerCase() }), y.fn = {
        constructor: Y.Z,
        length: 0,
        forEach: C.forEach,
        reduce: C.reduce,
        push: C.push,
        sort: C.sort,
        splice: C.splice,
        indexOf: C.indexOf,
        concat: function() { var a, b, c = []; for (a = 0; a < arguments.length; a++) b = arguments[a], c[a] = Y.isZ(b) ? b.toArray() : b; return D.apply(Y.isZ(this) ? this.toArray() : this, c) },
        map: function(a) { return y(y.map(this, function(b, c) { return a.call(b, c, b) })) },
        slice: function() { return y(F.apply(this, arguments)) },
        ready: function(a) { return U.test(G.readyState) && G.body ? a(y) : G.addEventListener("DOMContentLoaded", function() { a(y) }, !1), this },
        get: function(a) { return a === w ? F.call(this) : this[a >= 0 ? a : a + this.length] },
        toArray: function() { return this.get() },
        size: function() { return this.length },
        remove: function() { return this.each(function() { null != this.parentNode && this.parentNode.removeChild(this) }) },
        each: function(a) { return C.every.call(this, function(b, c) { return a.call(b, c, b) !== !1 }), this },
        filter: function(a) { return b(a) ? this.not(this.not(a)) : y(E.call(this, function(b) { return Y.matches(b, a) })) },
        add: function(a, b) { return y(B(this.concat(y(a, b)))) },
        is: function(a) { return this.length > 0 && Y.matches(this[0], a) },
        not: function(a) {
            var c = [];
            if (b(a) && a.call !== w) this.each(function(b) { a.call(this, b) || c.push(this) });
            else {
                var d = "string" == typeof a ? this.filter(a) : g(a) && b(a.item) ? F.call(a) : y(a);
                this.forEach(function(a) { d.indexOf(a) < 0 && c.push(a) })
            }
            return y(c)
        },
        has: function(a) { return this.filter(function() { return e(a) ? y.contains(this, a) : y(this).find(a).size() }) },
        eq: function(a) { return -1 === a ? this.slice(a) : this.slice(a, +a + 1) },
        first: function() { var a = this[0]; return a && !e(a) ? a : y(a) },
        last: function() { var a = this[this.length - 1]; return a && !e(a) ? a : y(a) },
        find: function(a) { var b, c = this; return b = a ? "object" == typeof a ? y(a).filter(function() { var a = this; return C.some.call(c, function(b) { return y.contains(b, a) }) }) : 1 == this.length ? y(Y.qsa(this[0], a)) : this.map(function() { return Y.qsa(this, a) }) : y() },
        closest: function(a, b) {
            var c = this[0],
                e = !1;
            for ("object" == typeof a && (e = y(a)); c && !(e ? e.indexOf(c) >= 0 : Y.matches(c, a));) c = c !== b && !d(c) && c.parentNode;
            return y(c)
        },
        parents: function(a) { for (var b = [], c = this; c.length > 0;) c = y.map(c, function(a) { return (a = a.parentNode) && !d(a) && b.indexOf(a) < 0 ? (b.push(a), a) : void 0 }); return q(b, a) },
        parent: function(a) { return q(B(this.pluck("parentNode")), a) },
        children: function(a) { return q(this.map(function() { return n(this) }), a) },
        contents: function() { return this.map(function() { return this.contentDocument || F.call(this.childNodes) }) },
        siblings: function(a) { return q(this.map(function(a, b) { return E.call(n(b.parentNode), function(a) { return a !== b }) }), a) },
        empty: function() { return this.each(function() { this.innerHTML = "" }) },
        pluck: function(a) { return y.map(this, function(b) { return b[a] }) },
        show: function() { return this.each(function() { "none" == this.style.display && (this.style.display = ""), "none" == getComputedStyle(this, "").getPropertyValue("display") && (this.style.display = m(this.nodeName)) }) },
        replaceWith: function(a) { return this.before(a).remove() },
        wrap: function(a) {
            var c = b(a);
            if (this[0] && !c) var d = y(a).get(0),
                e = d.parentNode || this.length > 1;
            return this.each(function(b) { y(this).wrapAll(c ? a.call(this, b) : e ? d.cloneNode(!0) : d) })
        },
        wrapAll: function(a) {
            if (this[0]) {
                y(this[0]).before(a = y(a));
                for (var b;
                    (b = a.children()).length;) a = b.first();
                y(a).append(this)
            }
            return this
        },
        wrapInner: function(a) {
            var c = b(a);
            return this.each(function(b) {
                var d = y(this),
                    e = d.contents(),
                    f = c ? a.call(this, b) : a;
                e.length ? e.wrapAll(f) : d.append(f)
            })
        },
        unwrap: function() { return this.parent().each(function() { y(this).replaceWith(y(this).children()) }), this },
        clone: function() { return this.map(function() { return this.cloneNode(!0) }) },
        hide: function() { return this.css("display", "none") },
        toggle: function(a) {
            return this.each(function() {
                var b = y(this);
                (a === w ? "none" == b.css("display") : a) ? b.show(): b.hide()
            })
        },
        prev: function(a) { return y(this.pluck("previousElementSibling")).filter(a || "*") },
        next: function(a) { return y(this.pluck("nextElementSibling")).filter(a || "*") },
        html: function(a) {
            return 0 in arguments ? this.each(function(b) {
                var c = this.innerHTML;
                y(this).empty().append(r(this, a, b, c))
            }) : 0 in this ? this[0].innerHTML : null
        },
        text: function(a) {
            return 0 in arguments ? this.each(function(b) {
                var c = r(this, a, b, this.textContent);
                this.textContent = null == c ? "" : "" + c
            }) : 0 in this ? this[0].textContent : null
        },
        attr: function(a, b) {
            var c;
            return "string" != typeof a || 1 in arguments ? this.each(function(c) {
                if (1 === this.nodeType)
                    if (e(a))
                        for (x in a) s(this, x, a[x]);
                    else s(this, a, r(this, b, c, this.getAttribute(a)))
            }) : this.length && 1 === this[0].nodeType ? !(c = this[0].getAttribute(a)) && a in this[0] ? this[0][a] : c : w
        },
        removeAttr: function(a) { return this.each(function() { 1 === this.nodeType && a.split(" ").forEach(function(a) { s(this, a) }, this) }) },
        prop: function(a, b) { return a = $[a] || a, 1 in arguments ? this.each(function(c) { this[a] = r(this, b, c, this[a]) }) : this[0] && this[0][a] },
        data: function(a, b) {
            var c = "data-" + a.replace(O, "-$1").toLowerCase(),
                d = 1 in arguments ? this.attr(c, b) : this.attr(c);
            return null !== d ? u(d) : w
        },
        val: function(a) { return 0 in arguments ? this.each(function(b) { this.value = r(this, a, b, this.value) }) : this[0] && (this[0].multiple ? y(this[0]).find("option").filter(function() { return this.selected }).pluck("value") : this[0].value) },
        offset: function(a) {
            if (a) return this.each(function(b) {
                var c = y(this),
                    d = r(this, a, b, c.offset()),
                    e = c.offsetParent().offset(),
                    f = { top: d.top - e.top, left: d.left - e.left };
                "static" == c.css("position") && (f.position = "relative"), c.css(f)
            });
            if (!this.length) return null;
            if (!y.contains(G.documentElement, this[0])) return { top: 0, left: 0 };
            var b = this[0].getBoundingClientRect();
            return { left: b.left + window.pageXOffset, top: b.top + window.pageYOffset, width: Math.round(b.width), height: Math.round(b.height) }
        },
        css: function(b, c) {
            if (arguments.length < 2) { var d, e = this[0]; if (!e) return; if (d = getComputedStyle(e, ""), "string" == typeof b) return e.style[A(b)] || d.getPropertyValue(b); if (_(b)) { var f = {}; return y.each(b, function(a, b) { f[b] = e.style[A(b)] || d.getPropertyValue(b) }), f } }
            var g = "";
            if ("string" == a(b)) c || 0 === c ? g = j(b) + ":" + l(b, c) : this.each(function() { this.style.removeProperty(j(b)) });
            else
                for (x in b) b[x] || 0 === b[x] ? g += j(x) + ":" + l(x, b[x]) + ";" : this.each(function() { this.style.removeProperty(j(x)) });
            return this.each(function() { this.style.cssText += ";" + g })
        },
        index: function(a) { return a ? this.indexOf(y(a)[0]) : this.parent().children().indexOf(this[0]) },
        hasClass: function(a) { return a ? C.some.call(this, function(a) { return this.test(t(a)) }, k(a)) : !1 },
        addClass: function(a) {
            return a ? this.each(function(b) {
                if ("className" in this) {
                    z = [];
                    var c = t(this),
                        d = r(this, a, b, c);
                    d.split(/\s+/g).forEach(function(a) { y(this).hasClass(a) || z.push(a) }, this), z.length && t(this, c + (c ? " " : "") + z.join(" "))
                }
            }) : this
        },
        removeClass: function(a) {
            return this.each(function(b) {
                if ("className" in this) {
                    if (a === w) return t(this, "");
                    z = t(this), r(this, a, b, z).split(/\s+/g).forEach(function(a) { z = z.replace(k(a), " ") }), t(this, z.trim())
                }
            })
        },
        toggleClass: function(a, b) {
            return a ? this.each(function(c) {
                var d = y(this),
                    e = r(this, a, c, t(this));
                e.split(/\s+/g).forEach(function(a) {
                    (b === w ? !d.hasClass(a) : b) ? d.addClass(a): d.removeClass(a)
                })
            }) : this
        },
        scrollTop: function(a) { if (this.length) { var b = "scrollTop" in this[0]; return a === w ? b ? this[0].scrollTop : this[0].pageYOffset : this.each(b ? function() { this.scrollTop = a } : function() { this.scrollTo(this.scrollX, a) }) } },
        scrollLeft: function(a) { if (this.length) { var b = "scrollLeft" in this[0]; return a === w ? b ? this[0].scrollLeft : this[0].pageXOffset : this.each(b ? function() { this.scrollLeft = a } : function() { this.scrollTo(a, this.scrollY) }) } },
        position: function() {
            if (this.length) {
                var a = this[0],
                    b = this.offsetParent(),
                    c = this.offset(),
                    d = N.test(b[0].nodeName) ? { top: 0, left: 0 } : b.offset();
                return c.top -= parseFloat(y(a).css("margin-top")) || 0, c.left -= parseFloat(y(a).css("margin-left")) || 0, d.top += parseFloat(y(b[0]).css("border-top-width")) || 0, d.left += parseFloat(y(b[0]).css("border-left-width")) || 0, { top: c.top - d.top, left: c.left - d.left }
            }
        },
        offsetParent: function() { return this.map(function() { for (var a = this.offsetParent || G.body; a && !N.test(a.nodeName) && "static" == y(a).css("position");) a = a.offsetParent; return a }) }
    }, y.fn.detach = y.fn.remove, ["width", "height"].forEach(function(a) {
        var b = a.replace(/./, function(a) { return a[0].toUpperCase() });
        y.fn[a] = function(e) { var f, g = this[0]; return e === w ? c(g) ? g["inner" + b] : d(g) ? g.documentElement["scroll" + b] : (f = this.offset()) && f[a] : this.each(function(b) { g = y(this), g.css(a, r(this, e, b, g[a]())) }) }
    }), Q.forEach(function(b, c) {
        var d = c % 2;
        y.fn[b] = function() {
            var b, e, f = y.map(arguments, function(c) { return b = a(c), "object" == b || "array" == b || null == c ? c : Y.fragment(c) }),
                g = this.length > 1;
            return f.length < 1 ? this : this.each(function(a, b) {
                e = d ? b : b.parentNode, b = 0 == c ? b.nextSibling : 1 == c ? b.firstChild : 2 == c ? b : null;
                var h = y.contains(G.documentElement, e);
                f.forEach(function(a) {
                    if (g) a = a.cloneNode(!0);
                    else if (!e) return y(a).remove();
                    e.insertBefore(a, b), h && v(a, function(a) { null == a.nodeName || "SCRIPT" !== a.nodeName.toUpperCase() || a.type && "text/javascript" !== a.type || a.src || window.eval.call(window, a.innerHTML) })
                })
            })
        }, y.fn[d ? b + "To" : "insert" + (c ? "Before" : "After")] = function(a) { return y(a)[b](this), this }
    }), Y.Z.prototype = o.prototype = y.fn, Y.uniq = B, Y.deserializeValue = u, y.zepto = Y, y
}();
window.Zepto = Zepto, void 0 === window.$ && (window.$ = Zepto);
! function(a) {
    function b(a) { return a._zid || (a._zid = m++) }

    function c(a, c, f, g) { if (c = d(c), c.ns) var h = e(c.ns); return (q[b(a)] || []).filter(function(a) { return !(!a || c.e && a.e != c.e || c.ns && !h.test(a.ns) || f && b(a.fn) !== b(f) || g && a.sel != g) }) }

    function d(a) { var b = ("" + a).split("."); return { e: b[0], ns: b.slice(1).sort().join(" ") } }

    function e(a) { return new RegExp("(?:^| )" + a.replace(" ", " .* ?") + "(?: |$)") }

    function f(a, b) { return a.del && !s && a.e in t || !!b }

    function g(a) { return u[a] || s && t[a] || a }

    function h(c, e, h, i, k, m, n) {
        var o = b(c),
            p = q[o] || (q[o] = []);
        e.split(/\s/).forEach(function(b) {
            if ("ready" == b) return a(document).ready(h);
            var e = d(b);
            e.fn = h, e.sel = k, e.e in u && (h = function(b) { var c = b.relatedTarget; return !c || c !== this && !a.contains(this, c) ? e.fn.apply(this, arguments) : void 0 }), e.del = m;
            var o = m || h;
            e.proxy = function(a) { if (a = j(a), !a.isImmediatePropagationStopped()) { a.data = i; var b = o.apply(c, a._args == l ? [a] : [a].concat(a._args)); return b === !1 && (a.preventDefault(), a.stopPropagation()), b } }, e.i = p.length, p.push(e), "addEventListener" in c && c.addEventListener(g(e.e), e.proxy, f(e, n))
        })
    }

    function i(a, d, e, h, i) {
        var j = b(a);
        (d || "").split(/\s/).forEach(function(b) { c(a, b, e, h).forEach(function(b) { delete q[j][b.i], "removeEventListener" in a && a.removeEventListener(g(b.e), b.proxy, f(b, i)) }) })
    }

    function j(b, c) {
        return (c || !b.isDefaultPrevented) && (c || (c = b), a.each(y, function(a, d) {
            var e = c[a];
            b[a] = function() { return this[d] = v, e && e.apply(c, arguments) }, b[d] = w
        }), (c.defaultPrevented !== l ? c.defaultPrevented : "returnValue" in c ? c.returnValue === !1 : c.getPreventDefault && c.getPreventDefault()) && (b.isDefaultPrevented = v)), b
    }

    function k(a) { var b, c = { originalEvent: a }; for (b in a) x.test(b) || a[b] === l || (c[b] = a[b]); return j(c, a) }
    var l, m = 1,
        n = Array.prototype.slice,
        o = a.isFunction,
        p = function(a) { return "string" == typeof a },
        q = {},
        r = {},
        s = "onfocusin" in window,
        t = { focus: "focusin", blur: "focusout" },
        u = { mouseenter: "mouseover", mouseleave: "mouseout" };
    r.click = r.mousedown = r.mouseup = r.mousemove = "MouseEvents", a.event = { add: h, remove: i }, a.proxy = function(c, d) { var e = 2 in arguments && n.call(arguments, 2); if (o(c)) { var f = function() { return c.apply(d, e ? e.concat(n.call(arguments)) : arguments) }; return f._zid = b(c), f } if (p(d)) return e ? (e.unshift(c[d], c), a.proxy.apply(null, e)) : a.proxy(c[d], c); throw new TypeError("expected function") }, a.fn.bind = function(a, b, c) { return this.on(a, b, c) }, a.fn.unbind = function(a, b) { return this.off(a, b) }, a.fn.one = function(a, b, c, d) { return this.on(a, b, c, d, 1) };
    var v = function() { return !0 },
        w = function() { return !1 },
        x = /^([A-Z]|returnValue$|layer[XY]$)/,
        y = { preventDefault: "isDefaultPrevented", stopImmediatePropagation: "isImmediatePropagationStopped", stopPropagation: "isPropagationStopped" };
    a.fn.delegate = function(a, b, c) { return this.on(b, a, c) }, a.fn.undelegate = function(a, b, c) { return this.off(b, a, c) }, a.fn.live = function(b, c) { return a(document.body).delegate(this.selector, b, c), this }, a.fn.die = function(b, c) { return a(document.body).undelegate(this.selector, b, c), this }, a.fn.on = function(b, c, d, e, f) { var g, j, m = this; return b && !p(b) ? (a.each(b, function(a, b) { m.on(a, c, d, b, f) }), m) : (p(c) || o(e) || e === !1 || (e = d, d = c, c = l), (e === l || d === !1) && (e = d, d = l), e === !1 && (e = w), m.each(function(l, m) { f && (g = function(a) { return i(m, a.type, e), e.apply(this, arguments) }), c && (j = function(b) { var d, f = a(b.target).closest(c, m).get(0); return f && f !== m ? (d = a.extend(k(b), { currentTarget: f, liveFired: m }), (g || e).apply(f, [d].concat(n.call(arguments, 1)))) : void 0 }), h(m, b, e, d, c, j || g) })) }, a.fn.off = function(b, c, d) { var e = this; return b && !p(b) ? (a.each(b, function(a, b) { e.off(a, c, b) }), e) : (p(c) || o(d) || d === !1 || (d = c, c = l), d === !1 && (d = w), e.each(function() { i(this, b, d, c) })) }, a.fn.trigger = function(b, c) { return b = p(b) || a.isPlainObject(b) ? a.Event(b) : j(b), b._args = c, this.each(function() { b.type in t && "function" == typeof this[b.type] ? this[b.type]() : "dispatchEvent" in this ? this.dispatchEvent(b) : a(this).triggerHandler(b, c) }) }, a.fn.triggerHandler = function(b, d) { var e, f; return this.each(function(g, h) { e = k(p(b) ? a.Event(b) : b), e._args = d, e.target = h, a.each(c(h, b.type || b), function(a, b) { return f = b.proxy(e), e.isImmediatePropagationStopped() ? !1 : void 0 }) }), f }, "focusin focusout focus blur load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error".split(" ").forEach(function(b) { a.fn[b] = function(a) { return 0 in arguments ? this.bind(b, a) : this.trigger(b) } }), a.Event = function(a, b) {
        p(a) || (b = a, a = b.type);
        var c = document.createEvent(r[a] || "Events"),
            d = !0;
        if (b)
            for (var e in b) "bubbles" == e ? d = !!b[e] : c[e] = b[e];
        return c.initEvent(a, d, !0), j(c)
    }
}(Zepto);
! function(a) {
    function b(a, b, c, d) { return Math.abs(a - b) >= Math.abs(c - d) ? a - b > 0 ? "Left" : "Right" : c - d > 0 ? "Up" : "Down" }

    function c() { k = null, m.last && (m.el.trigger("longTap"), m = {}) }

    function d() { k && clearTimeout(k), k = null }

    function e() { h && clearTimeout(h), i && clearTimeout(i), j && clearTimeout(j), k && clearTimeout(k), h = i = j = k = null, m = {} }

    function f(a) { return ("touch" == a.pointerType || a.pointerType == a.MSPOINTER_TYPE_TOUCH) && a.isPrimary }

    function g(a, b) { return a.type == "pointer" + b || a.type.toLowerCase() == "mspointer" + b }
    var h, i, j, k, l, m = {},
        n = 750;
    a(document).ready(function() {
        var o, p, q, r, s = 0,
            t = 0;
        "MSGesture" in window && (l = new MSGesture, l.target = document.body), a(document).bind("MSGestureEnd", function(a) {
            var b = a.velocityX > 1 ? "Right" : a.velocityX < -1 ? "Left" : a.velocityY > 1 ? "Down" : a.velocityY < -1 ? "Up" : null;
            b && (m.el.trigger("swipe"), m.el.trigger("swipe" + b))
        }).on("touchstart MSPointerDown pointerdown", function(b) {
            (!(r = g(b, "down")) || f(b)) && (q = r ? b : b.touches[0], b.touches && 1 === b.touches.length && m.x2 && (m.x2 = void 0, m.y2 = void 0), o = Date.now(), p = o - (m.last || o), m.el = a("tagName" in q.target ? q.target : q.target.parentNode), h && clearTimeout(h), m.x1 = q.pageX, m.y1 = q.pageY, p > 0 && 250 >= p && (m.isDoubleTap = !0), m.last = o, k = setTimeout(c, n), l && r && l.addPointer(b.pointerId))
        }).on("touchmove MSPointerMove pointermove", function(a) {
            (!(r = g(a, "move")) || f(a)) && (q = r ? a : a.touches[0], d(), m.x2 = q.pageX, m.y2 = q.pageY, s += Math.abs(m.x1 - m.x2), t += Math.abs(m.y1 - m.y2))
        }).on("touchend MSPointerUp pointerup", function(c) {
            (!(r = g(c, "up")) || f(c)) && (d(), m.x2 && Math.abs(m.x1 - m.x2) > 30 || m.y2 && Math.abs(m.y1 - m.y2) > 30 ? j = setTimeout(function() { m.el.trigger("swipe"), m.el.trigger("swipe" + b(m.x1, m.x2, m.y1, m.y2)), m = {} }, 0) : "last" in m && (30 > s && 30 > t ? i = setTimeout(function() {
                var b = a.Event("tap");
                b.cancelTouch = e, m.el.trigger(b), m.isDoubleTap ? (m.el && m.el.trigger("doubleTap"), m = {}) : h = setTimeout(function() { h = null, m.el && m.el.trigger("singleTap"), m = {} }, 250)
            }, 0) : m = {}), s = t = 0)
        }).on("touchcancel MSPointerCancel pointercancel", e), a(window).on("scroll", e)
    }), ["swipe", "swipeLeft", "swipeRight", "swipeUp", "swipeDown", "doubleTap", "tap", "singleTap", "longTap"].forEach(function(b) { a.fn[b] = function(a) { return this.on(b, a) } })
}(Zepto);
! function(a) {
    function b(b, c, d) { var e = a.Event(c); return a(b).trigger(e, d), !e.isDefaultPrevented() }

    function c(a, c, d, e) { return a.global ? b(c || s, d, e) : void 0 }

    function d(b) { b.global && 0 === a.active++ && c(b, null, "ajaxStart") }

    function e(b) { b.global && !--a.active && c(b, null, "ajaxStop") }

    function f(a, b) { var d = b.context; return b.beforeSend.call(d, a, b) === !1 || c(b, d, "ajaxBeforeSend", [a, b]) === !1 ? !1 : void c(b, d, "ajaxSend", [a, b]) }

    function g(a, b, d, e) {
        var f = d.context,
            g = "success";
        d.success.call(f, a, g, b), e && e.resolveWith(f, [a, g, b]), c(d, f, "ajaxSuccess", [b, d, a]), i(g, b, d)
    }

    function h(a, b, d, e, f) {
        var g = e.context;
        e.error.call(g, d, b, a), f && f.rejectWith(g, [d, b, a]), c(e, g, "ajaxError", [d, e, a || b]), i(b, d, e)
    }

    function i(a, b, d) {
        var f = d.context;
        d.complete.call(f, b, a), c(d, f, "ajaxComplete", [b, d]), e(d)
    }

    function j() {}

    function k(a) { return a && (a = a.split(";", 2)[0]), a && (a == x ? "html" : a == w ? "json" : u.test(a) ? "script" : v.test(a) && "xml") || "text" }

    function l(a, b) { return "" == b ? a : (a + "&" + b).replace(/[&?]{1,2}/, "?") }

    function m(b) { b.processData && b.data && "string" != a.type(b.data) && (b.data = a.param(b.data, b.traditional)), !b.data || b.type && "GET" != b.type.toUpperCase() || (b.url = l(b.url, b.data), b.data = void 0) }

    function n(b, c, d, e) { return a.isFunction(c) && (e = d, d = c, c = void 0), a.isFunction(d) || (e = d, d = void 0), { url: b, data: c, success: d, dataType: e } }

    function o(b, c, d, e) {
        var f, g = a.isArray(c),
            h = a.isPlainObject(c);
        a.each(c, function(c, i) { f = a.type(i), e && (c = d ? e : e + "[" + (h || "object" == f || "array" == f ? c : "") + "]"), !e && g ? b.add(i.name, i.value) : "array" == f || !d && "object" == f ? o(b, i, d, c) : b.add(c, i) })
    }
    var p, q, r = 0,
        s = window.document,
        t = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
        u = /^(?:text|application)\/javascript/i,
        v = /^(?:text|application)\/xml/i,
        w = "application/json",
        x = "text/html",
        y = /^\s*$/,
        z = s.createElement("a");
    z.href = window.location.href, a.active = 0, a.ajaxJSONP = function(b, c) {
        if (!("type" in b)) return a.ajax(b);
        var d, e, i = b.jsonpCallback,
            j = (a.isFunction(i) ? i() : i) || "jsonp" + ++r,
            k = s.createElement("script"),
            l = window[j],
            m = function(b) { a(k).triggerHandler("error", b || "abort") },
            n = { abort: m };
        return c && c.promise(n), a(k).on("load error", function(f, i) { clearTimeout(e), a(k).off().remove(), "error" != f.type && d ? g(d[0], n, b, c) : h(null, i || "error", n, b, c), window[j] = l, d && a.isFunction(l) && l(d[0]), l = d = void 0 }), f(n, b) === !1 ? (m("abort"), n) : (window[j] = function() { d = arguments }, k.src = b.url.replace(/\?(.+)=\?/, "?$1=" + j), s.head.appendChild(k), b.timeout > 0 && (e = setTimeout(function() { m("timeout") }, b.timeout)), n)
    }, a.ajaxSettings = { type: "GET", beforeSend: j, success: j, error: j, complete: j, context: null, global: !0, xhr: function() { return new window.XMLHttpRequest }, accepts: { script: "text/javascript, application/javascript, application/x-javascript", json: w, xml: "application/xml, text/xml", html: x, text: "text/plain" }, crossDomain: !1, timeout: 0, processData: !0, cache: !0 }, a.ajax = function(b) {
        var c, e, i = a.extend({}, b || {}),
            n = a.Deferred && a.Deferred();
        for (p in a.ajaxSettings) void 0 === i[p] && (i[p] = a.ajaxSettings[p]);
        d(i), i.crossDomain || (c = s.createElement("a"), c.href = i.url, c.href = c.href, i.crossDomain = z.protocol + "//" + z.host != c.protocol + "//" + c.host), i.url || (i.url = window.location.toString()), (e = i.url.indexOf("#")) > -1 && (i.url = i.url.slice(0, e)), m(i);
        var o = i.dataType,
            r = /\?.+=\?/.test(i.url);
        if (r && (o = "jsonp"), i.cache !== !1 && (b && b.cache === !0 || "script" != o && "jsonp" != o) || (i.url = l(i.url, "_=" + Date.now())), "jsonp" == o) return r || (i.url = l(i.url, i.jsonp ? i.jsonp + "=?" : i.jsonp === !1 ? "" : "callback=?")), a.ajaxJSONP(i, n);
        var t, u = i.accepts[o],
            v = {},
            w = function(a, b) { v[a.toLowerCase()] = [a, b] },
            x = /^([\w-]+:)\/\//.test(i.url) ? RegExp.$1 : window.location.protocol,
            A = i.xhr(),
            B = A.setRequestHeader;
        if (n && n.promise(A), i.crossDomain || w("X-Requested-With", "XMLHttpRequest"), w("Accept", u || "*/*"), (u = i.mimeType || u) && (u.indexOf(",") > -1 && (u = u.split(",", 2)[0]), A.overrideMimeType && A.overrideMimeType(u)), (i.contentType || i.contentType !== !1 && i.data && "GET" != i.type.toUpperCase()) && w("Content-Type", i.contentType || "application/x-www-form-urlencoded"), i.headers)
            for (q in i.headers) w(q, i.headers[q]);
        if (A.setRequestHeader = w, A.onreadystatechange = function() {
                if (4 == A.readyState) {
                    A.onreadystatechange = j, clearTimeout(t);
                    var b, c = !1;
                    if (A.status >= 200 && A.status < 300 || 304 == A.status || 0 == A.status && "file:" == x) {
                        o = o || k(i.mimeType || A.getResponseHeader("content-type")), b = A.responseText;
                        try { "script" == o ? (1, eval)(b) : "xml" == o ? b = A.responseXML : "json" == o && (b = y.test(b) ? null : a.parseJSON(b)) } catch (d) { c = d }
                        c ? h(c, "parsererror", A, i, n) : g(b, A, i, n)
                    } else h(A.statusText || null, A.status ? "error" : "abort", A, i, n)
                }
            }, f(A, i) === !1) return A.abort(), h(null, "abort", A, i, n), A;
        if (i.xhrFields)
            for (q in i.xhrFields) A[q] = i.xhrFields[q];
        var C = "async" in i ? i.async : !0;
        A.open(i.type, i.url, C, i.username, i.password);
        for (q in v) B.apply(A, v[q]);
        return i.timeout > 0 && (t = setTimeout(function() { A.onreadystatechange = j, A.abort(), h(null, "timeout", A, i, n) }, i.timeout)), A.send(i.data ? i.data : null), A
    }, a.get = function() { return a.ajax(n.apply(null, arguments)) }, a.post = function() { var b = n.apply(null, arguments); return b.type = "POST", a.ajax(b) }, a.getJSON = function() { var b = n.apply(null, arguments); return b.dataType = "json", a.ajax(b) }, a.fn.load = function(b, c, d) {
        if (!this.length) return this;
        var e, f = this,
            g = b.split(/\s/),
            h = n(b, c, d),
            i = h.success;
        return g.length > 1 && (h.url = g[0], e = g[1]), h.success = function(b) { f.html(e ? a("<div>").html(b.replace(t, "")).find(e) : b), i && i.apply(f, arguments) }, a.ajax(h), this
    };
    var A = encodeURIComponent;
    a.param = function(b, c) { var d = []; return d.add = function(b, c) { a.isFunction(c) && (c = c()), null == c && (c = ""), this.push(A(b) + "=" + A(c)) }, o(d, b, c), d.join("&").replace(/%20/g, "+") }
}(Zepto);
! function(a) {
    a.fn.serializeArray = function() {
        var b, c, d = [],
            e = function(a) { return a.forEach ? a.forEach(e) : void d.push({ name: b, value: a }) };
        return this[0] && a.each(this[0].elements, function(d, f) { c = f.type, b = f.name, b && "fieldset" != f.nodeName.toLowerCase() && !f.disabled && "submit" != c && "reset" != c && "button" != c && "file" != c && ("radio" != c && "checkbox" != c || f.checked) && e(a(f).val()) }), d
    }, a.fn.serialize = function() { var a = []; return this.serializeArray().forEach(function(b) { a.push(encodeURIComponent(b.name) + "=" + encodeURIComponent(b.value)) }), a.join("&") }, a.fn.submit = function(b) {
        if (0 in arguments) this.bind("submit", b);
        else if (this.length) {
            var c = a.Event("submit");
            this.eq(0).trigger(c), c.isDefaultPrevented() || this.get(0).submit()
        }
        return this
    }
}(Zepto);
! function(a) {
    function b(a, b) {
        var c = this.os = {},
            d = this.browser = {},
            e = a.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
            f = a.match(/(Android);?[\s\/]+([\d.]+)?/),
            g = !!a.match(/\(Macintosh\; Intel /),
            h = a.match(/(iPad).*OS\s([\d_]+)/),
            i = a.match(/(iPod)(.*OS\s([\d_]+))?/),
            j = !h && a.match(/(iPhone\sOS)\s([\d_]+)/),
            k = a.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
            l = /Win\d{2}|Windows/.test(b),
            m = a.match(/Windows Phone ([\d.]+)/),
            n = k && a.match(/TouchPad/),
            o = a.match(/Kindle\/([\d.]+)/),
            p = a.match(/Silk\/([\d._]+)/),
            q = a.match(/(BlackBerry).*Version\/([\d.]+)/),
            r = a.match(/(BB10).*Version\/([\d.]+)/),
            s = a.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
            t = a.match(/PlayBook/),
            u = a.match(/Chrome\/([\d.]+)/) || a.match(/CriOS\/([\d.]+)/),
            v = a.match(/Firefox\/([\d.]+)/),
            w = a.match(/\((?:Mobile|Tablet); rv:([\d.]+)\).*Firefox\/[\d.]+/),
            x = a.match(/MSIE\s([\d.]+)/) || a.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
            y = !u && a.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
            z = y || a.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/);
        (d.webkit = !!e) && (d.version = e[1]), f && (c.android = !0, c.version = f[2]), j && !i && (c.ios = c.iphone = !0, c.version = j[2].replace(/_/g, ".")), h && (c.ios = c.ipad = !0, c.version = h[2].replace(/_/g, ".")), i && (c.ios = c.ipod = !0, c.version = i[3] ? i[3].replace(/_/g, ".") : null), m && (c.wp = !0, c.version = m[1]), k && (c.webos = !0, c.version = k[2]), n && (c.touchpad = !0), q && (c.blackberry = !0, c.version = q[2]), r && (c.bb10 = !0, c.version = r[2]), s && (c.rimtabletos = !0, c.version = s[2]), t && (d.playbook = !0), o && (c.kindle = !0, c.version = o[1]), p && (d.silk = !0, d.version = p[1]), !p && c.android && a.match(/Kindle Fire/) && (d.silk = !0), u && (d.chrome = !0, d.version = u[1]), v && (d.firefox = !0, d.version = v[1]), w && (c.firefoxos = !0, c.version = w[1]), x && (d.ie = !0, d.version = x[1]), z && (g || c.ios || l) && (d.safari = !0, c.ios || (d.version = z[1])), y && (d.webview = !0), c.tablet = !!(h || t || f && !a.match(/Mobile/) || v && a.match(/Tablet/) || x && !a.match(/Phone/) && a.match(/Touch/)), c.phone = !(c.tablet || c.ipod || !(f || j || k || q || r || u && a.match(/Android/) || u && a.match(/CriOS\/([\d.]+)/) || v && a.match(/Mobile/) || x && a.match(/Touch/)))
    }
    b.call(a, navigator.userAgent, navigator.platform), a.__detect = b
}(Zepto);
! function(a, b) {
    function c(a) { return a.replace(/([a-z])([A-Z])/, "$1-$2").toLowerCase() }

    function d(a) { return e ? e + a : a.toLowerCase() }
    var e, f, g, h, i, j, k, l, m, n, o = "",
        p = { Webkit: "webkit", Moz: "", O: "o" },
        q = document.createElement("div"),
        r = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i,
        s = {};
    a.each(p, function(a, c) { return q.style[a + "TransitionProperty"] !== b ? (o = "-" + a.toLowerCase() + "-", e = c, !1) : void 0 }), f = o + "transform", s[g = o + "transition-property"] = s[h = o + "transition-duration"] = s[j = o + "transition-delay"] = s[i = o + "transition-timing-function"] = s[k = o + "animation-name"] = s[l = o + "animation-duration"] = s[n = o + "animation-delay"] = s[m = o + "animation-timing-function"] = "", a.fx = { off: e === b && q.style.transitionProperty === b, speeds: { _default: 400, fast: 200, slow: 600 }, cssPrefix: o, transitionEnd: d("TransitionEnd"), animationEnd: d("AnimationEnd") }, a.fn.animate = function(c, d, e, f, g) { return a.isFunction(d) && (f = d, e = b, d = b), a.isFunction(e) && (f = e, e = b), a.isPlainObject(d) && (e = d.easing, f = d.complete, g = d.delay, d = d.duration), d && (d = ("number" == typeof d ? d : a.fx.speeds[d] || a.fx.speeds._default) / 1e3), g && (g = parseFloat(g) / 1e3), this.anim(c, d, e, f, g) }, a.fn.anim = function(d, e, o, p, q) {
        var t, u, v, w = {},
            x = "",
            y = this,
            z = a.fx.transitionEnd,
            A = !1;
        if (e === b && (e = a.fx.speeds._default / 1e3), q === b && (q = 0), a.fx.off && (e = 0), "string" == typeof d) w[k] = d, w[l] = e + "s", w[n] = q + "s", w[m] = o || "linear", z = a.fx.animationEnd;
        else {
            u = [];
            for (t in d) r.test(t) ? x += t + "(" + d[t] + ") " : (w[t] = d[t], u.push(c(t)));
            x && (w[f] = x, u.push(f)), e > 0 && "object" == typeof d && (w[g] = u.join(", "), w[h] = e + "s", w[j] = q + "s", w[i] = o || "linear")
        }
        return v = function(b) {
            if ("undefined" != typeof b) {
                if (b.target !== b.currentTarget) return;
                a(b.target).unbind(z, v)
            } else a(this).unbind(z, v);
            A = !0, a(this).css(s), p && p.call(this)
        }, e > 0 && (this.bind(z, v), setTimeout(function() { A || v.call(y) }, 1e3 * (e + q) + 25)), this.size() && this.get(0).clientLeft, this.css(w), 0 >= e && setTimeout(function() { y.each(function() { v.call(this) }) }, 0), this
    }, q = null
}(Zepto);
! function(a, b) {
    function c(c, d, e, f, g) { "function" != typeof d || g || (g = d, d = b); var h = { opacity: e }; return f && (h.scale = f, c.css(a.fx.cssPrefix + "transform-origin", "0 0")), c.animate(h, d, null, g) }

    function d(b, d, e, f) { return c(b, d, 0, e, function() { g.call(a(this)), f && f.call(this) }) }
    var e = window.document,
        f = (e.documentElement, a.fn.show),
        g = a.fn.hide,
        h = a.fn.toggle;
    a.fn.show = function(a, d) { return f.call(this), a === b ? a = 0 : this.css("opacity", 0), c(this, a, 1, "1,1", d) }, a.fn.hide = function(a, c) { return a === b ? g.call(this) : d(this, a, "0,0", c) }, a.fn.toggle = function(c, d) {
        return c === b || "boolean" == typeof c ? h.call(this, c) : this.each(function() {
            var b = a(this);
            b["none" == b.css("display") ? "show" : "hide"](c, d)
        })
    }, a.fn.fadeTo = function(a, b, d) { return c(this, a, b, null, d) }, a.fn.fadeIn = function(a, b) { var c = this.css("opacity"); return c > 0 ? this.css("opacity", 0) : c = 1, f.call(this).fadeTo(a, c, b) }, a.fn.fadeOut = function(a, b) { return d(this, a, null, b) }, a.fn.fadeToggle = function(b, c) {
        return this.each(function() {
            var d = a(this);
            d[0 == d.css("opacity") || "none" == d.css("display") ? "fadeIn" : "fadeOut"](b, c)
        })
    }
}(Zepto);
! function(a) {
    function b(b, d) {
        var i = b[h],
            j = i && e[i];
        if (void 0 === d) return j || c(b);
        if (j) { if (d in j) return j[d]; var k = g(d); if (k in j) return j[k] }
        return f.call(a(b), d)
    }

    function c(b, c, f) {
        var i = b[h] || (b[h] = ++a.uuid),
            j = e[i] || (e[i] = d(b));
        return void 0 !== c && (j[g(c)] = f), j
    }

    function d(b) { var c = {}; return a.each(b.attributes || i, function(b, d) { 0 == d.name.indexOf("data-") && (c[g(d.name.replace("data-", ""))] = a.zepto.deserializeValue(d.value)) }), c }
    var e = {},
        f = a.fn.data,
        g = a.camelCase,
        h = a.expando = "Zepto" + +new Date,
        i = [];
    a.fn.data = function(d, e) { return void 0 === e ? a.isPlainObject(d) ? this.each(function(b, e) { a.each(d, function(a, b) { c(e, a, b) }) }) : 0 in this ? b(this[0], d) : void 0 : this.each(function() { c(this, d, e) }) }, a.fn.removeData = function(b) {
        return "string" == typeof b && (b = b.split(/\s+/)), this.each(function() {
            var c = this[h],
                d = c && e[c];
            d && a.each(b || d, function(a) { delete d[b ? g(this) : a] })
        })
    }, ["remove", "empty"].forEach(function(b) {
        var c = a.fn[b];
        a.fn[b] = function() { var a = this.find("*"); return "remove" === b && (a = a.add(this)), a.removeData(), c.call(this) }
    })
}(Zepto);
! function(a) {
    function b(c) {
        var d = [
                ["resolve", "done", a.Callbacks({ once: 1, memory: 1 }), "resolved"],
                ["reject", "fail", a.Callbacks({ once: 1, memory: 1 }), "rejected"],
                ["notify", "progress", a.Callbacks({ memory: 1 })]
            ],
            e = "pending",
            f = {
                state: function() { return e },
                always: function() { return g.done(arguments).fail(arguments), this },
                then: function() {
                    var c = arguments;
                    return b(function(b) {
                        a.each(d, function(d, e) {
                            var h = a.isFunction(c[d]) && c[d];
                            g[e[1]](function() {
                                var c = h && h.apply(this, arguments);
                                if (c && a.isFunction(c.promise)) c.promise().done(b.resolve).fail(b.reject).progress(b.notify);
                                else {
                                    var d = this === f ? b.promise() : this,
                                        g = h ? [c] : arguments;
                                    b[e[0] + "With"](d, g)
                                }
                            })
                        }), c = null
                    }).promise()
                },
                promise: function(b) { return null != b ? a.extend(b, f) : f }
            },
            g = {};
        return a.each(d, function(a, b) {
            var c = b[2],
                h = b[3];
            f[b[1]] = c.add, h && c.add(function() { e = h }, d[1 ^ a][2].disable, d[2][2].lock), g[b[0]] = function() { return g[b[0] + "With"](this === g ? f : this, arguments), this }, g[b[0] + "With"] = c.fireWith
        }), f.promise(g), c && c.call(g, g), g
    }
    var c = Array.prototype.slice;
    a.when = function(d) {
        var e, f, g, h = c.call(arguments),
            i = h.length,
            j = 0,
            k = 1 !== i || d && a.isFunction(d.promise) ? i : 0,
            l = 1 === k ? d : b(),
            m = function(a, b, d) { return function(f) { b[a] = this, d[a] = arguments.length > 1 ? c.call(arguments) : f, d === e ? l.notifyWith(b, d) : --k || l.resolveWith(b, d) } };
        if (i > 1)
            for (e = new Array(i), f = new Array(i), g = new Array(i); i > j; ++j) h[j] && a.isFunction(h[j].promise) ? h[j].promise().done(m(j, g, h)).fail(l.reject).progress(m(j, f, e)) : --k;
        return k || l.resolveWith(g, h), l.promise()
    }, a.Deferred = b
}(Zepto);
! function(a) {
    a.Callbacks = function(b) {
        b = a.extend({}, b);
        var c, d, e, f, g, h, i = [],
            j = !b.once && [],
            k = function(a) {
                for (c = b.memory && a, d = !0, h = f || 0, f = 0, g = i.length, e = !0; i && g > h; ++h)
                    if (i[h].apply(a[0], a[1]) === !1 && b.stopOnFalse) { c = !1; break }
                e = !1, i && (j ? j.length && k(j.shift()) : c ? i.length = 0 : l.disable())
            },
            l = {
                add: function() {
                    if (i) {
                        var d = i.length,
                            h = function(c) { a.each(c, function(a, c) { "function" == typeof c ? b.unique && l.has(c) || i.push(c) : c && c.length && "string" != typeof c && h(c) }) };
                        h(arguments), e ? g = i.length : c && (f = d, k(c))
                    }
                    return this
                },
                remove: function() {
                    return i && a.each(arguments, function(b, c) {
                        for (var d;
                            (d = a.inArray(c, i, d)) > -1;) i.splice(d, 1), e && (g >= d && --g, h >= d && --h)
                    }), this
                },
                has: function(b) { return !(!i || !(b ? a.inArray(b, i) > -1 : i.length)) },
                empty: function() { return g = i.length = 0, this },
                disable: function() { return i = j = c = void 0, this },
                disabled: function() { return !i },
                lock: function() { return j = void 0, c || l.disable(), this },
                locked: function() { return !j },
                fireWith: function(a, b) { return !i || d && !j || (b = b || [], b = [a, b.slice ? b.slice() : b], e ? j.push(b) : k(b)), this },
                fire: function() { return l.fireWith(this, arguments) },
                fired: function() { return !!d }
            };
        return l
    }
}(Zepto);
! function(a) {
    function b(b) { return b = a(b), !(!b.width() && !b.height()) && "none" !== b.css("display") }

    function c(a, b) {
        a = a.replace(/=#\]/g, '="#"]');
        var c, d, e = h.exec(a);
        if (e && e[2] in g && (c = g[e[2]], d = e[3], a = e[1], d)) {
            var f = Number(d);
            d = isNaN(f) ? d.replace(/^["']|["']$/g, "") : f
        }
        return b(a, c, d)
    }
    var d = a.zepto,
        e = d.qsa,
        f = d.matches,
        g = a.expr[":"] = { visible: function() { return b(this) ? this : void 0 }, hidden: function() { return b(this) ? void 0 : this }, selected: function() { return this.selected ? this : void 0 }, checked: function() { return this.checked ? this : void 0 }, parent: function() { return this.parentNode }, first: function(a) { return 0 === a ? this : void 0 }, last: function(a, b) { return a === b.length - 1 ? this : void 0 }, eq: function(a, b, c) { return a === c ? this : void 0 }, contains: function(b, c, d) { return a(this).text().indexOf(d) > -1 ? this : void 0 }, has: function(a, b, c) { return d.qsa(this, c).length ? this : void 0 } },
        h = new RegExp("(.*):(\\w+)(?:\\(([^)]+)\\))?$\\s*"),
        i = /^\s*>/,
        j = "Zepto" + +new Date;
    d.qsa = function(b, f) { return c(f, function(c, g, h) { try { var k;!c && g ? c = "*" : i.test(c) && (k = a(b).addClass(j), c = "." + j + " " + c); var l = e(b, c) } catch (m) { throw console.error("error performing selector: %o", f), m } finally { k && k.removeClass(j) } return g ? d.uniq(a.map(l, function(a, b) { return g.call(a, b, l, h) })) : l }) }, d.matches = function(a, b) { return c(b, function(b, c, d) { return !(b && !f(a, b) || c && c.call(a, null, d) !== a) }) }
}(Zepto);
! function(a) {
    function b(a) { return "tagName" in a ? a : a.parentNode }
    if (a.os.ios) {
        var c, d = {};
        a(document).bind("gesturestart", function(a) {
            {
                var e = Date.now();
                e - (d.last || e)
            }
            d.target = b(a.target), c && clearTimeout(c), d.e1 = a.scale, d.last = e
        }).bind("gesturechange", function(a) { d.e2 = a.scale }).bind("gestureend", function() { d.e2 > 0 ? (0 != Math.abs(d.e1 - d.e2) && a(d.target).trigger("pinch") && a(d.target).trigger("pinch" + (d.e1 - d.e2 > 0 ? "In" : "Out")), d.e1 = d.e2 = d.last = 0) : "last" in d && (d = {}) }), ["pinch", "pinchIn", "pinchOut"].forEach(function(b) { a.fn[b] = function(a) { return this.bind(b, a) } })
    }
}(Zepto);
! function(a) {
    a.fn.end = function() { return this.prevObject || a() }, a.fn.andSelf = function() { return this.add(this.prevObject || a()) }, "filter,add,not,eq,first,last,find,closest,parents,parent,children,siblings".split(",").forEach(function(b) {
        var c = a.fn[b];
        a.fn[b] = function() { var a = c.apply(this, arguments); return a.prevObject = this, a }
    })
}(Zepto);
! function(a) {
    var b, c = [];
    a.fn.remove = function() { return this.each(function() { this.parentNode && ("IMG" === this.tagName && (c.push(this), this.src = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=", b && clearTimeout(b), b = setTimeout(function() { c = [] }, 6e4)), this.parentNode.removeChild(this)) }) }
}(Zepto);
! function(a) {
    String.prototype.trim === a && (String.prototype.trim = function() { return this.replace(/^\s+|\s+$/g, "") }), Array.prototype.reduce === a && (Array.prototype.reduce = function(b) {
        if (void 0 === this || null === this) throw new TypeError;
        var c, d = Object(this),
            e = d.length >>> 0,
            f = 0;
        if ("function" != typeof b) throw new TypeError;
        if (0 == e && 1 == arguments.length) throw new TypeError;
        if (arguments.length >= 2) c = arguments[1];
        else
            for (;;) { if (f in d) { c = d[f++]; break } if (++f >= e) throw new TypeError }
        for (; e > f;) f in d && (c = b.call(a, c, d[f], f, d)), f++;
        return c
    })
}();
//core
! function(a) {
    function b(b, d) {
        var i = b[h],
            j = i && e[i];
        if (void 0 === d) return j || c(b);
        if (j) { if (d in j) return j[d]; var k = g(d); if (k in j) return j[k] }
        return f.call(a(b), d)
    }

    function c(b, c, f) {
        var i = b[h] || (b[h] = ++a.uuid),
            j = e[i] || (e[i] = d(b));
        return void 0 !== c && (j[g(c)] = f), j
    }

    function d(b) { var c = {}; return a.each(b.attributes || i, function(b, d) { 0 == d.name.indexOf("data-") && (c[g(d.name.replace("data-", ""))] = a.zepto.deserializeValue(d.value)) }), c }
    var e = {},
        f = a.fn.data,
        g = a.camelCase,
        h = a.expando = "Zepto" + +new Date,
        i = [];
    a.fn.data = function(d, e) { return void 0 === e ? a.isPlainObject(d) ? this.each(function(b, e) { a.each(d, function(a, b) { c(e, a, b) }) }) : 0 in this ? b(this[0], d) : void 0 : this.each(function() { c(this, d, e) }) }, a.fn.removeData = function(b) {
        return "string" == typeof b && (b = b.split(/\s+/)), this.each(function() {
            var c = this[h],
                d = c && e[c];
            d && a.each(b || d, function(a) { delete d[b ? g(this) : a] })
        })
    }, ["remove", "empty"].forEach(function(b) {
        var c = a.fn[b];
        a.fn[b] = function() { var a = this.find("*"); return "remove" === b && (a = a.add(this)), a.removeData(), c.call(this) }
    })
}(window.Zepto), ! function(a) {
    var b = {};
    b.cache = {}, a.tpl = function(a, c, d) {
        var e = /[^\w\-\.:]/.test(a) ? function(a, b) {
            var c, d = [],
                f = [];
            for (c in a) d.push(c), f.push(a[c]);
            return new Function(d, e.code).apply(b || a, f)
        } : b.cache[a] = b.cache[a] || this.get(document.getElementById(a).innerHTML);
        return e.code = e.code || "var $parts=[]; $parts.push('" + a.replace(/\\/g, "\\\\").replace(/[\r\t\n]/g, " ").split("<%").join("	").replace(/(^|%>)[^\t]*/g, function(a) { return a.replace(/'/g, "\\'") }).replace(/\t=(.*?)%>/g, "',$1,'").split("	").join("');").split("%>").join("$parts.push('") + "'); return $parts.join('');", c ? e(c, d) : e
    }, a.adaptObject = function(b, c, d, e, f, g) {
        var h = b;
        if ("string" != typeof d) {
            var i = a.extend({}, c, "object" == typeof d && d),
                j = !1;
            a.isArray(h) && h.length && "script" == a(h)[0].nodeName.toLowerCase() ? (h = a(a.tpl(h[0].innerHTML, i)).appendTo("body"), j = !0) : a.isArray(h) && h.length && "" == h.selector ? (h = a(a.tpl(h[0].outerHTML, i)).appendTo("body"), j = !0) : a.isArray(h) || (h = a(a.tpl(e, i)).appendTo("body"), j = !0)
        }
        return h.each(function() {
            var b = a(this),
                e = b.data("fz." + g);
            e || b.data("fz." + g, e = new f(this, a.extend({}, c, "object" == typeof d && d), j)), "string" == typeof d && e[d]()
        })
    }
}(window.Zepto);
//YL
! function(a) {
    a && a.extend(String.prototype, {
        replaceAll: function(os, ns) { return this.replace(new RegExp(os, 'gm'), ns) },
        sliceAfter: function(str) { return (this.indexOf(str) >= 0) ? this.substring(this.indexOf(str) + str.length, this.length) : '' },
        padLeft: function(width, ch) { if (this.length >= width) return this.toString(); return this._pad(width, ch, 0) },
        _pad: function(width, ch, side) { var str = [side ? '' : this, side ? this : '']; while (str[side].length < (width ? width : 0) && (str[side] = str[1] + (ch || ' ') + str[0])); return str[side] },
        parseJSON: function() { return (new Function("return " + this.toString()))() },
        parseDate: function() { return (new Date()).parse(this.toString()) },
        sliceBefore: function(str) { return (this.indexOf(str) >= 0) ? this.substring(0, this.indexOf(str)) : '' },
        padLeft: function(width, ch) { if (this.length >= width) return this.toString(); return this._pad(width, ch, 0) },
        isMobile: function() { return (new RegExp(/^(13|14|15|17|18)\d{9}$/).test(this.trim())) },
        isNumber: function() { return !isNaN(this) },
        isAlphanumeric: function() { return (new RegExp(/^[a-zA-Z0-9]+$/).test(this.trim())) },
        _pad: function(width, ch, side) { var str = [side ? '' : this, side ? this : '']; while (str[side].length < (width ? width : 0) && (str[side] = str[1] + (ch || ' ') + str[0])); return str[side] },
        startWith: function(start, noCase) { return !(noCase ? this.toLowerCase().indexOf(start.toLowerCase()) : this.indexOf(start)) },
        escapeReg: function() { return this.replace(new RegExp("([.*+?^=!:${}()|[\\]/\\\\])", "g"), "\\$1") },
        getPathName: function() { var a = this.toString(); return a.indexOf("?") > 0 && (a = a.sliceBefore("?")), a.indexOf("#") > 0 && (a = a.sliceBefore("#")), a },
        addQueryValue: function(b, c) {
            var d = this.getPathName(),
                e = this.getQueryJson();
            return e[b] || (e[b] = c), d + "?" + a.param(e)
        },
        getQueryValue: function(a) {
            var b = new RegExp("(^|&|\\?|#)" + a.escapeReg() + "=([^&]*)(&|$)", ""),
                c = this.match(b);
            return c ? c[2] : ""
        },
        getQueryJson: function() { if (this.indexOf("?") < 0) return {}; for (var a, b, c, d, e = this.substr(this.indexOf("?") + 1), f = e.split("&"), g = f.length, h = {}, i = 0; g > i; i++) d = f[i].split("="), a = d[0], b = d[1], c = h[a], "undefined" == typeof c ? h[a] = b : "[object Array]" == Object.prototype.toString.call(c) ? c.push(b) : h[a] = [c, b]; return h },
        format: function(a) {
            var b = this;
            if (arguments.length > 0) {
                var c = 1 == arguments.length && $.isArray(arguments[0]) ? arguments[0] : $.makeArray(arguments);
                $.each(c, function(a, c) { b = b.replace(new RegExp("\\{" + a + "\\}", "g"), c) })
            }
            return b
        },
        substitute: function(a) { return a && "object" == typeof a ? this.replace(/\{([^{}]+)\}/g, function(b, c) { var d = a[c]; return void 0 !== d ? "" + d : "" }) : this.toString() }
    })
}(Zepto), (function(a) {
    a && a.extend(Number.prototype, {
        comma: function(length) {
            if (!length || length < 1) length = 3;
            var source = ('' + this).split('.');
            source[0] = source[0].replace(new RegExp('(\\d)(?=(\\d{' + length + '})+$)', 'ig'), '$1,');
            return source.join('.')
        },
        randomInt: function(min, max) { return Math.floor(Math.random() * (max - min + 1) + min) },
        padLeft: function(width, ch) { return ('' + this).padLeft(width, ch) },
        padRight: function(width, ch) { return ('' + this).padRight(width, ch) }
    })
})(Zepto),
function(a) { a && a.extend(Array.prototype, { indexOf: function(item, it) { for (var i = 0; i < this.length; i++) { if (item == ((it) ? this[i][it] : this[i])) return i } return -1 } }) }(Zepto),
function(a) {
    a && a.extend(Date.prototype, {
        parse: function(time) { if (typeof(time) == 'string') { if (time.indexOf('GMT') > 0 || time.indexOf('gmt') > 0 || !isNaN(Date.parse(time))) { return this._parseGMT(time) } else if (time.indexOf('UTC') > 0 || time.indexOf('utc') > 0 || time.indexOf(',') > 0) { return this._parseUTC(time) } else { return this._parseCommon(time) } } return new Date() },
        _parseGMT: function(time) { this.setTime(Date.parse(time)); return this },
        _parseUTC: function(time) { return (new Date(time)) },
        _parseCommon: function(time) {
            var d = time.split(/ |T/),
                d1 = d.length > 1 ? d[1].split(/[^\d]/) : [0, 0, 0],
                d0 = d[0].split(/[^\d]/);
            return new Date(d0[0] - 0, d0[1] - 1, d0[2] - 0, (d1[0] || 0) - 0, (d1[1] || 0) - 0, (d1[2] || 0) - 0)
        },
        clone: function() { return new Date().setTime(this.getTime()) },
        dateAdd: function(type, val) {
            var _y = this.getFullYear();
            var _m = this.getMonth();
            var _d = this.getDate();
            var _h = this.getHours();
            var _n = this.getMinutes();
            var _s = this.getSeconds();
            switch (type) {
                case 'y':
                    this.setFullYear(_y + val);
                    break;
                case 'm':
                    this.setMonth(_m + val);
                    break;
                case 'd':
                    this.setDate(_d + val);
                    break;
                case 'h':
                    this.setHours(_h + val);
                    break;
                case 'n':
                    this.setMinutes(_n + val);
                    break;
                case 's':
                    this.setSeconds(_s + val);
                    break
            }
            return this
        },
        dateDiff: function(type, date2) {
            var diff = date2 - this;
            switch (type) {
                case 'w':
                    return diff / 1000 / 3600 / 24 / 7;
                case 'd':
                    return diff / 1000 / 3600 / 24;
                case 'h':
                    return diff / 1000 / 3600;
                case 'n':
                    return diff / 1000 / 60;
                case 's':
                    return diff / 1000
            }
        },
        format: function(format) { if (isNaN(this)) return ''; var o = { 'm+': this.getMonth() + 1, 'd+': this.getDate(), 'h+': this.getHours(), 'n+': this.getMinutes(), 's+': this.getSeconds(), 'S': this.getMilliseconds(), 'W': ['日', '一', '二', '三', '四', '五', '六'][this.getDay()], 'q+': Math.floor((this.getMonth() + 3) / 3) }; if (format.indexOf('am/pm') >= 0) { format = format.replace('am/pm', (o['h+'] >= 12) ? '下午' : '上午'); if (o['h+'] >= 12) o['h+'] -= 12 } if (/(y+)/.test(format)) { format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length)) } for (var k in o) { if (new RegExp('(' + k + ')').test(format)) { format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)) } } return format }
    })
}(Zepto),
function($) {
    $.browser = $.browser || {};
    $.extend($.browser, (function() {
        var ua = navigator.userAgent.toLowerCase(),
            os, version;
        if (ua.indexOf('uleapp/') > 0) {
            version = ua.sliceAfter('uleapp/').split('_')[3];
            os = ua.sliceAfter('uleapp/').sliceBefore('_');
            if (ua.sliceAfter('uleapp/').split('_')[1] == 'ule') { var uappType = { ule: true, ylxd: false } } else { var uappType = { ule: false, ylxd: true } }
            var appobj = $.extend({ ios: os == 'ios', android: os == 'android', version: version }, uappType);
            return appobj
        } else if (ua.indexOf('ulxdapp/') > 0) {
            version = ua.sliceAfter('ulxdapp/').split('_')[3];
            os = ua.sliceAfter('ulxdapp/').sliceBefore('_');
            return { ylxd: true, wx: false, ios: os == 'ios', android: os == 'android', version: version }
        } else if (ua.indexOf('uzgapp/') > 0) {
            version = ua.sliceAfter('uzgapp/').split('_')[3];
            os = ua.sliceAfter('uzgapp/').sliceBefore('_');
            return { uzg: true, wx: false, ios: os == 'ios', android: os == 'android', version: version }
        } else { return { ule: false, uzg: false, ylxd: false, wx: ua.match(/micromessenger/i), ios: ua.match(/(iphone|ipod|ipad);?/i), android: ua.match(/android/i) } }
    })())
}(Zepto),
function($) {
    $.extend($.fn, {
        attrJSON: function(attr) { return (this.attr(attr || 'rel') || '').parseAttrJSON() },
        lazyload: function() {
            var oThis = this,
                extend_height = 400;

            function inViewport(el) { var top = window.pageYOffset; var btm = window.pageYOffset + window.innerHeight; var elTop = $(el).offset().top; return elTop >= top && elTop - extend_height <= btm }
            $(window).bind('scroll', function() {
                $('img.lazy').each(function(index, node) {
                    var $this = $(this);
                    if (!$this.data('src')) { return }
                    if (!inViewport(this)) return $this.attr('src', $this.data('src'));
                    $this.error(function() { $this.attr('src', 'https://i2.ule.com/i/global/noimage_450.jpg') }).removeClass('lazy');
                    console.log('scroll')
                })
            }).trigger('scroll')
        }
    })
}(Zepto),
function($) {
    $.extend($, {
        makeArray: function(G) { var E = []; if (G != null) { var F = G.length; if (F == null || typeof G === "string" || $.isFunction(G) || G.setInterval) { E[0] = G } else { while (F) { E[--F] = G[F] } } } return E },
        getJSONPSUPER: function(url, options, data, callback) {
            var options = $.extend({ callback: 'callback', timeout: 10000 }, options);
            var jsre = /=\?/,
                jsonp = 'json' + (+new Date()) + parseInt(Math.random() * 100);
            if (!jsre.test(url)) { url += (url.match(/\?/) ? "&" : "?") + options.callback + "=?" }
            if (typeof(data) == "function") { callback = data, data = {} }
            url = url.replace(jsre, "=" + jsonp);
            url += '&' + $.param(data);
            var head = document.getElementsByTagName("head")[0];
            var script = document.createElement("script");
            script.src = url;
            var tId = null,
                __run = function(tmp) {
                    if (!tId) return;
                    clearTimeout(tId);
                    tId = null;
                    callback && callback(tmp);
                    try { delete window[jsonp] } catch (e) {}
                    if (head) head.removeChild(script)
                };
            window[jsonp] = function(tmp) { __run(tmp) };
            $(script).error(function() { __run(false) });
            tId = setTimeout(function() { __run('timeout') }, options.timeout);
            head.appendChild(script)
        },
        getScript: function(url, callback) {
            var head = document.getElementsByTagName('head')[0],
                js = document.createElement('script');
            js.setAttribute('type', 'text/javascript');
            js.setAttribute('src', url);
            head.appendChild(js);
            var callbackFn = function() { if (typeof callback === 'function') { callback() } };
            if (document.all) { js.onreadystatechange = function() { if (js.readyState == 'loaded' || js.readyState == 'complete') { callbackFn() } } } else { js.onload = function() { callbackFn() } }
        }
    })
}(Zepto),
function($) {
    $ && (window.JEND || (window.JEND = {}), JEND.tipBox = function(t) {
        var _tip, tID;
        t && (_tip && _tip.remove() && clearTimeout(tID), _tip = $('<div class="wrapper"><div class="tips_overlay"><div class="tipBox"><div class="msg"><h2><i></i>' + t + '</h2></div></div></div></div>').appendTo('body'), setTimeout(function() { _tip.children('.tips_overlay').addClass("overlay-in"), _tip.children(".tipBox").addClass("mask-in") }, 10), tID = setTimeout(function() { _tip && (_tip.addClass("overlay-out"), _tip.children(".tipBox").addClass("mask-out"), _tip.remove(), _tip = null) }, 2e3))
    }, JEND.namespace = function(name, sep) {
        var s = name.split(sep || '.'),
            d = {},
            o = function(a, b, c) {
                if (c < b.length) {
                    if (!a[b[c]]) { a[b[c]] = {} }
                    d = a[b[c]];
                    o(a[b[c]], b, c + 1)
                }
            };
        o(window, s, 0);
        return d
    }, JEND.define = function(name, value, callback) {
        var obj = this,
            item = name;
        if (name.indexOf('.') > 0) {
            var a = name.split('.');
            item = a.pop();
            var source = a.join('.');
            obj = JEND.namespace(source)
        }
        if (obj[item]) return;
        obj[item] = value;
        if (callback) callback()
    }, JEND.ready = function(callback) { JEND.ready.addEvent(callback) }, $.extend(JEND.ready, {
        events: [],
        addEvent: function(callback) {
            if (!this.events) { callback(); return }
            this.events.push(callback)
        },
        exeEvents: function() {
            if (!this.events) return;
            for (var i = 0; i < this.events.length; i++) { this.events[i]() }
            this.events = null
        }
    }), JEND.load = function(service, action, params) {
        if ($.isArray(service)) {
            var url = service.join(',');
            var urlsize = service.length;
            var status = JEND.loader.checkFileLoader(url);
            if (status == urlsize + 1) { if (typeof(action) == 'function') action() } else if (status > 0) { JEND.loader.addExecute(url, action) } else if (status === 0) {
                JEND.loader.addExecute(url, action);
                JEND.loader.fileLoader[url] = 1;
                for (var i = 0; i < urlsize; i++) { JEND.load(service[i], function() { JEND.loader.fileLoader[url]++; if (JEND.loader.fileLoader[url] == urlsize + 1) { JEND.loader.execute(url) } }) }
            }
        } else if (JEND.loader.serviceLibs[service] && JEND.loader.serviceLibs[service].requires) { JEND.load(JEND.loader.serviceLibs[service].requires, function() { JEND.load.run(service, action, params) }) } else { JEND.load.run(service, action, params) }
    }, $.extend(JEND.load, {
        setPath: function(path) { JEND.loader.serviceBase = path },
        add: function(key, data) {
            if (JEND.loader.serviceLibs[key]) return;
            if (data.js && (!data.js.startWith('http')) && this.version) { data.js = data.js.addQueryValue('v', this.version) }
            if (data.css && (!data.css.startWith('http')) && this.version) { data.css = data.css.addQueryValue('v', this.version) }
            JEND.loader.serviceLibs[key] = data
        },
        run: function(service, act, params) {
            var action = (typeof(act) == 'string') ? (function() { try { var o = eval('JEND.' + service); if (o && o[act]) o[act](params) } catch (e) {} }) : (act || function() {});
            if (JEND.loader.checkService(service)) { action(); return }
            var url = JEND.loader.getServiceUrl(service);
            var status = JEND.loader.checkFileLoader(url);
            if (status === 2) { action() } else if (status === 1) { JEND.loader.addExecute(url, action) } else if (status === 0) {
                if ($('script[src="' + url + '"]').length > 0) {
                    JEND.loader.fileLoader[url] = 2;
                    action()
                } else {
                    JEND.loader.addExecute(url, action);
                    JEND.loader.addScript(service)
                }
            } else { console.error('加载异常') }
        }
    }), JEND.define('JEND.loader', {
        fileLoader: {},
        executeLoader: {},
        serviceBase: '',
        serviceLibs: {},
        checkFullUrl: function(url) { return (url.indexOf('/') === 0 || url.indexOf('http://') === 0 || url.indexOf('https://') === 0) },
        checkService: function(service) { if (this.checkFullUrl(service)) return false; try { if (service.indexOf('.') > 0) { var o = eval('JEND.' + service); return (typeof(o) != 'undefined') } return false } catch (e) { return false } },
        checkFileLoader: function(url) { return (url !== '') ? (this.fileLoader[url] || 0) : -1 },
        getServiceUrl: function(service) { var url = ''; if (this.checkFullUrl(service)) { url = service } else if (this.serviceLibs[service]) { url = (this.checkFullUrl(this.serviceLibs[service].js)) ? this.serviceLibs[service].js : (this.serviceBase + this.serviceLibs[service].js) } return url },
        execute: function(url) {
            if (this.executeLoader[url]) {
                for (var i = 0; i < this.executeLoader[url].length; i++) { this.executeLoader[url][i]() }
                this.executeLoader[url] = null
            }
        },
        addExecute: function(url, action) {
            if (typeof(action) != 'function') return;
            if (!this.executeLoader[url]) this.executeLoader[url] = [];
            this.executeLoader[url].push(action)
        },
        addScript: function(service) {
            var this_ = this,
                url;
            if (this.checkFullUrl(service)) {
                url = service;
                this.getScript(url, function() {
                    this_.fileLoader[url] = 2;
                    JEND.loader.execute(url)
                })
            } else if (this.serviceLibs[service]) {
                if (this.serviceLibs[service].css) {
                    url = (this.checkFullUrl(this.serviceLibs[service].css)) ? this.serviceLibs[service].css : (this.serviceBase + this.serviceLibs[service].css);
                    if (!this.fileLoader[url]) {
                        this.fileLoader[url] = 1;
                        $('head').append('<link rel="stylesheet" type="text\/css"  href="' + url + '" \/>')
                    }
                }
                if (this.serviceLibs[service].js) {
                    url = (this.checkFullUrl(this.serviceLibs[service].js)) ? this.serviceLibs[service].js : (this.serviceBase + this.serviceLibs[service].js);
                    this.getScript(url, function() {
                        this_.fileLoader[url] = 2;
                        JEND.loader.execute(url)
                    })
                }
            }
        },
        getScript: function(url, onSuccess, onError) {
            this.fileLoader[url] = 1;
            this.getRemoteScript(url, onSuccess, onError)
        },
        getRemoteScript: function(url, param, onSuccess, onError) {
            if ($.isFunction(param)) {
                onError = onSuccess;
                onSuccess = param;
                param = {}
            }
            var head = document.getElementsByTagName("head")[0];
            var script = document.createElement("script");
            script.type = 'text/javascript';
            script.charset = 'utf-8';
            script.src = url;
            for (var item in param) { if (item == 'keepScriptTag') { script.keepScriptTag = true } else { script.setAttribute(item, param[item]) } }
            script.onload = script.onreadystatechange = function() {
                if (!this.readyState || this.readyState == "loaded" || this.readyState == "complete") {
                    if (onSuccess) onSuccess();
                    script.onload = script.onreadystatechange = null;
                    if (!script.keepScriptTag) head.removeChild(script)
                }
            };
            script.onerror = function() { if (onError) onError() };
            head.appendChild(script)
        }
    }))
}(Zepto),
function(a) {
    a && window.JEND && (JEND.namespace("JEND.track"), JEND.track.scriptPath = document.location.protocol + "//i1.", JEND.track.disabled = "1" == location.href.getQueryValue("no_track") ? !0 : !1, JEND.track.init = function(b) {
        if (!this.disabled) {
            var c = this;
            b = a.extend({ baidu: !0, google: !0, rubi: !1, dsp: !1, mediav: !1 }, b || {}), b.baidu && this.baidu.init();
            if (document.getElementsByTagName('body')[0].getAttribute('data-uspm')) { this.uspm.init(function() { c.ule.init() }) } else { c.ule.init() }
        }
    }, JEND.track.loadJS = function(a, b, c) { b ? JEND.loader.getRemoteScript(a, { async: !0, keepScriptTag: !0 }, c) : document.write(unescape('%3Cscript type="text/javascript" src="' + a + '"%3E%3C/script%3E')) }, JEND.track.timestat = { loadTime: window._jend_page_loadtime || 0, initTime: (new Date).getTime(), datas: {}, add: function(a) { this.datas[a] = (new Date).getTime() - (this.loadTime || this.initTime) }, get: function(a) { return this.datas[a] || 0 } }, JEND.track.uspm = { init: function(a) { JEND.track.loadJS(JEND.track.scriptPath + JEND.server.ulecdnUrl + "/app/yxd/j/yl/uspm.min.js", !0, a) } }, JEND.track.ule = { init: function() { JEND.track.loadJS(JEND.track.scriptPath + JEND.server.ulecdnUrl + "/j/uletrack.js", !0) }, sendEvent: function(a, b, c, d) { window._utrack && _utrack.push(["_trackEvent", a, b || "", c || "", d || ""]) } }, JEND.track.baidu = {
        disabled: JEND.track.disabled,
        uid: "",
        setUid: function(a) { this.uid = a },
        init: function(a) {
            var b = "",
                c = "";
            this.inited || this.disabled || (this.inited = !0, c = location.host, /ule.com$/i.test(c) && (this.uid = "35367fc738ea2f9946dca07f732e96df"), /ule.com.hk$/i.test(c) && (this.uid = "778ceb7fcbf6884491be44cf9548dd7d"), /ulenp.com$/i.test(c) && (this.uid = "8b98ea018c05efee8f9115b32486deae"), /trip.ule.com$/i.test(c) && (this.uid = "664e19c93cc419d220e2f62478e99877"), /wholesale.ule.com$/i.test(c) && (this.uid = "a5ee578bf22cf92a4e5ae1e1ff5b38c2"), b = navigator.userAgent.replace(/\s/g, ""), JEND.track.loadJS("https://hm.baidu.com/hm.js?" + this.uid, !0), console.log("init baidu track"))
        },
        sendEvent: function(a, b, c, d) {!this.disabled && window._hmt && (_hmt.push(["_trackEvent", a, b || "", c || "", d || ""]), JEND.debug("send baidu event", { category: a, action: b, label: c, value: d })) }
    }, JEND.track.google = {
        disabled: JEND.track.disabled,
        uid: "UA-50969958-1",
        domain: "ule.com",
        setUid: function(a) { this.uid = a },
        setDomain: function(a) { this.domain = a },
        init: function(a, b) {
            if (!this.inited && !this.disabled) {
                this.inited = !0;
                var c = JEND.track.scriptPath + JEND.server.ulecdnUrl + "/googleana/analytics.js";
                ! function(a, b, c, d, e, f, g) {
                    a.GoogleAnalyticsObject = e, a[e] = a[e] || function() {
                        (a[e].q = a[e].q || []).push(arguments)
                    }, a[e].l = 1 * new Date, f = b.createElement(c), g = b.getElementsByTagName(c)[0], f.async = 1, f.src = d, g.parentNode.insertBefore(f, g)
                }(window, document, "script", c, "ga"), ga("create", a || this.uid, b || this.domain), ga("require", "displayfeatures"), ga("send", "pageview");
                var d = "//www.googletagmanager.com/gtm.js?id=";
                ! function(a, b, c, d, e, f) {
                    a[d] = a[d] || [], a[d].push({ "gtm.start": (new Date).getTime(), event: "gtm.js" });
                    var g = b.getElementsByTagName(c)[0],
                        h = b.createElement(c),
                        i = "dataLayer" != d ? "&l=" + d : "";
                    h.async = !0, h.src = f + e + i, g.parentNode.insertBefore(h, g)
                }(window, document, "script", "dataLayer", "GTM-MRM5R5", d), console.log("init google track")
            }
        },
        send: function(a, b) {!this.disabled && window.ga && (ga("send", a, b), console.log("send google ")) },
        initEC: function() {!this.disabled && window.ga && (ga("require", "ecommerce", "ecommerce.js"), console.log("init google ec")) },
        sendEC: function(a, b) {
            if (!this.disabled && window.ga) {
                a.metric4 && a.metric5 && (isNaN(a.metric4 + "." + a.metric5) || (a.tax = a.metric4 + "." + a.metric5)), ga("ecommerce:addTransaction", a);
                for (var c = 0; c < b.length; c++) ga("ecommerce:addItem", b[c]);
                ga("ecommerce:send"), console.log("send google ec")
            }
        }
    }, JEND.track.mediav = {
        disabled: !0,
        uid: "m-29284-0",
        attrs: [],
        setUid: function(a) { this.uid = a },
        pushAttr: function(a) { this.attrs.push(a) },
        pushProd: function(a) { this.disabled || (this.pagetype = "goodsdetail", this.pushAttr(["setPageUrl", a.link || ""]), this.pushAttr(["$addGoods", a.cateId || "", a.brandId || "", a.listingName || "", a.listingId || "", a.salePrice || "", a.imgUrl || "", a.cateName || "", a.brandName || "", a.storageStatus || 1, a.maxPrice || "", a.favorNum || "", a.expTime || ""]), this.pushAttr(["$logData"]), console.log("push mediav prod")) },
        pushOrder: function(a, b) {
            if (!this.disabled) {
                this.pagetype = "ordercreate", this.pushAttr(["$addOrder", a.id || "", a.revenue || 0]);
                for (var c = 0; c < b.length; c++) this.pushAttr(["$addItem", a.id || "", b[c].id || "", b[c].name || "", b[c].price || "", b[c].quantity || "", b[c].link || "", b[c].imgUrl || ""]);
                this.pushAttr(["$logData"]), console.log("push mediav order")
            }
        },
        init: function(a) { this.inited || this.disabled || (this.inited = !0, window._mvq = window._mvq || [], _mvq.push(["$setAccount", a || this.uid]), _mvq.push(["$setGeneral", this.pagetype || "", "", this.username || "", this.userid || ""]), _mvq.push(["$logConversion"]), _mvq.concat(this.attrs), JEND.track.loadJS("https:" == document.location.protocol ? "https://static-ssl.mediav.com/mvl.js" : "http://static.mediav.com/mvl.js", !0), console.log("init mediav track")) }
    }, JEND.track.dsp = { disabled: JEND.track.disabled, uid: "799", setUid: function(a) { this.uid = a }, init: function(a) { this.inited || this.disabled || (this.inited = !0, window._hdspq = window._hdspq || [], _hdspq.push(["_setVars", a || this.uid]), JEND.track.loadJS("http://v.behe.com/tracker/tk.js", !0), console.log("init dsp track")) } }, JEND.track.rubi = {
        disabled: JEND.track.disabled,
        uid: "4JPR8AQL",
        setUid: function(a) { this.uid = a },
        init: function(a) {
            if (!this.inited && !this.disabled) {
                if (this.inited = !0, window.rkID = a || this.uid, JEND.cookie.get("infoValue"))
                    for (var b = unescape(JEND.cookie.get("infoValue")).split("&"), c = 0; c < b.length; c++) {
                        var d = [];
                        d = b[c].split("="), "userId" == d[0] && (window.rkUserId = d[1])
                    } else window.rkUserId = 0;
                window.rkMerchantId = window.merchantId ? window.merchantId : 0, JEND.track.timestat.loadTime && (window.sLT = JEND.track.timestat.loadTime), "string" == typeof rkSubTotal && (rkSubTotal = parseFloat(rkSubTotal)), JEND.track.loadJS(JEND.track.scriptPath + JEND.server.ulecdnUrl + "/rubikloud/static/init.js", !0), console.log("init rubi track")
            }
        }
    })
}(Zepto),
function(a) {
    a && window.JEND && (JEND.namespace("JEND.cookie"), a.extend(JEND.cookie, {
        hasMailCookie: false,
        getRootDomain: function() {
            var d = document.domain;
            if (d.indexOf('.') > 0 && !d.isIP()) {
                var arr = d.split('.'),
                    len = arr.length,
                    d1 = arr[len - 1],
                    d2 = arr[len - 2],
                    d3 = arr[len - 3];
                d = (d2 == 'com' || d2 == 'net') ? (d3 + '.' + d2 + '.' + d1) : (d2 + '.' + d1)
            }
            return d
        },
        load: function() {
            var tC = document.cookie.split('; ');
            var tO = {};
            var a = null;
            for (var i = 0; i < tC.length; i++) {
                a = tC[i].split('=');
                tO[a[0]] = a[1]
            }
            return tO
        },
        get: function(name) { var value = this.load()[name]; if (value) { try { return decodeURI(value) } catch (e) { return unescape(value) } } else { return false } },
        set: function(name, value, options) {
            options = (typeof(options) == 'object') ? options : { minute: options };
            var arg_len = arguments.length;
            var path = (arg_len > 3) ? arguments[3] : (options.path || '/');
            var domain = (arg_len > 4) ? arguments[4] : (options.domain || (options.root ? this.getRootDomain() : ''));
            var exptime = 0;
            if (options.day) { exptime = 1000 * 60 * 60 * 24 * options.day } else if (options.hour) { exptime = 1000 * 60 * 60 * options.hour } else if (options.minute) { exptime = 1000 * 60 * options.minute } else if (options.second) { exptime = 1000 * options.second }
            var exp = new Date(),
                expires = '';
            if (exptime > 0) {
                exp.setTime(exp.getTime() + exptime);
                expires = '; expires=' + exp.toGMTString()
            }
            domain = (domain) ? ('; domain=' + domain) : '';
            document.cookie = name + '=' + escape(value || '') + '; path=' + path + domain + expires
        },
        del: function(name, options) {
            options = options || {};
            var path = '; path=' + (options.path || '/');
            var domain = (options.domain) ? ('; domain=' + options.domain) : '';
            if (options.root) domain = '; domain=' + this.getRootDomain();
            document.cookie = name + '=' + path + domain + '; expires=Thu,01-Jan-70 00:00:01 GMT'
        },
        checkUserStatus: function() { if (this.getCookie('mall_cookie')) { return true } else { return false } },
        getCookie: function(name) { var cookies = document.cookie.split(";"); for (var i = 0, len = cookies.length; i < len; i++) { if (cookies[i].split('=')[0].trim() == name) { return cookies[i].split('=')[1] } } }
    }))
}(Zepto),
function(a) {
    a && window.JEND && (JEND.server = { uleUrl: 'ule.com', name: '', ulecdnUrl: 'ulecdn.com' });
    var uleUrl = location.host.substring(location.host.indexOf('.') + 1);
    JEND.server.uleUrl = uleUrl;
    if (uleUrl == 'beta.ule.com') { JEND.server.ulecdnUrl = 'beta.ulecdn.com' }
}(Zepto),
function(a) {
    a && window.JEND && (JEND.namespace("JEND.systemTime"), a.extend(JEND.systemTime, {
        timeDiff: '',
        load: function(callback) {
            var that = this;
            $.getJSON('//pub.' + JEND.server.uleUrl + '/clock/datetime?type=2&callback=?', function(data) { that.timeDiff = new Date().getTime() - data.time; if (callback) callback() })
        },
        get: function(formatType) { var time = new Date(); if (this.timeDiff) { time = new Date(new Date().getTime() - this.timeDiff) } return (formatType) ? time.format(formatType) : time }
    }))
}(Zepto),
function(a) {
    a && window.JEND && (JEND.namespace("JEND.getStatus"), a.extend(JEND.getStatus, {
        getUserId: function(callback) {
            var oThis = this;
            $.ajax({ type: 'get', async: true, url: '//my.' + JEND.server.uleUrl + '/usr/getIndexCookies.do', dataType: 'jsonp', jsonp: 'jsonCallBack', success: function(obj) { callback && callback(oThis) }, error: function(jqXHR, errorStatus, errorThrown) { console.log('请求服务失败') } })
        },
        isLogin: function(callback) { var oThis = this; if (JEND.cookie.checkUserStatus()) { callback && callback.apply(oThis) } else { if ($.browser.ule) { location.href = 'uleMobile://uleLogin_' + location.href } else { if (JEND.cookie.getCookie('client_type') == 'wx_psbc') { location.href = '//m.' + JEND.server.uleUrl + '/user/relation?target=' + encodeURIComponent(location.href) } else { location.href = '//m.' + JEND.server.uleUrl + '/user/login?target=' + encodeURIComponent(location.href) } } } }
    }))
}(Zepto),
function(a) {
    a && window.JEND && (JEND.namespace("JEND.innerHead"), a.extend(JEND.innerHead, {
        init: function() {
            var oThis = this;
            var Params = oThis.getParams();
            if (Params.ishead == "false") {
                $("body").css({ "padding-top": "0px" });
                $('<style>nav.fixed{top:0px;}</style>').appendTo('head')
            } else {
                oThis.headHtml();
                oThis.popHtml()
            }
            // oThis.backup();
            oThis.getPageUrl = oThis.getParams();
            var skipApp = oThis.getPageUrl.skipApp;
            if (skipApp == 'true') { oThis.skipApp() }
        },
        headHtml: function() {
            var headHtml = '';
            var headTitle = document.title;
            var fix = "fix";
            if (headTitle == '') { headTitle = '活动' } else if (headTitle == "邮乐触屏版 - 订单取消进度") { headTitle = "订单取消进度" } else if (headTitle == "邮乐特卖") { headTitle = "天天特卖" } else if (headTitle == "生活缴费-订单中心") { headTitle = "订单中心" }
            $("body").css({ "padding-top": "40px" });
            $('<style>nav.fixed{top:40px;}</style>').appendTo('head');
            if ($.browser.ule) {
                if ($.browser.ios) {
                    if ($.browser.version > 367) {
                        $("body").css({ "padding-top": "60px" });
                        $('<style>nav.fixed{top:60px;}</style>').appendTo('head')
                    }
                }
            }
            headHtml = '<h3 class="headTitle ' + fix + '"><a href="javascript:history.back();" class="back"></a><p>' + headTitle + '</p><a href="javascript:;" class="classfiy"></a></h3>';
            $('body').prepend(headHtml)
        },
        popHtml: function() {
            var m = this;
            var popHtml = '';
            popHtml += '<div class="classfiy_pop">';
            popHtml += '<div class="mask"></div>';
            popHtml += '<ul class="classfiy_nav">';
            popHtml += '<li class="homeLi"><a href="//m.ule.com/"><b></b>首页</a></li>';
            popHtml += '<li class="classfiyLi"><a href="//m.ule.com/category/all.html"><b></b>分类</a></li>';
            popHtml += '<li class="cartLi"><a href="//m.ule.com/cart/list"><b></b>购物车</a></li>';
            popHtml += '<li class="my_centerLi"><a href="//m.ule.com/user/center"><b></b>我的邮乐</a></li>';
            popHtml += '</ul>';
            popHtml += '</div>';
            $('body').append(popHtml);
            $(".classfiy").click(function() { $(".classfiy_pop").show() });
            $(".classfiy_pop").click(function() { $(".classfiy_pop").hide() });
            var defultTitleH = '0';
            var appTitleH = '20px';
            var defultBackTop = '12px';
            var appBackTop = '32px';
            $(".headTitle").css({ "max-width": "640px", "background": "rgba(255,255,255,0.95)", "width": "100%", "position": "relative", "border-bottom": "1px solid rgba(255,255,255,0.95)", "margin": "0", "padding": defultTitleH });
            $(".headTitle.fix").css({ "position": "fixed", "top": "0px", "left": "auto", "z-index": "100" });
            $(".headTitle p").css({ "width": "70%", "margin": "0 auto", "height": "40px", "line-height": "40px", "font-family": "microsoft yahei", "color": "#333", "text-align": "center", "font-size": "16px", "font-weight": "400", "overflow": "hidden", "white-space": "nowrap", "text-overflow": "ellipsis" });
            $(".headTitle a.back").css({ "position": "absolute", "height": "14px", "width": "14px", "left": "15px", "top": defultBackTop, "border-top": "2px solid #666", "border-left": "2px solid #666", "transform": "rotate(-45deg)", "-webkit-transform": "rotate(-45deg)" });
            var headTitle = document.title;
            if (headTitle == "邮乐特卖" || headTitle == "邮乐触屏版 - 订单取消进度" || headTitle == "邮乐触屏版 - 可用商品") { $('.headTitle a.classfiy').remove() }
            if ($.browser.ule) {
                $('.headTitle .back').attr('href', 'ulemobile://ulePopView');
                $('.headTitle a.classfiy').remove()
            }
            $('.headTitle a.classfiy').css({ 'background': 'url(//i0.ulecdn.com/ulewap/i/goodsDetail/icon-more.png) center center no-repeat', 'height': '40px', 'display': 'inline-block', 'background-size': '30px', 'width': '50px', 'margin-right': '0', 'position': 'absolute', 'right': '0', 'top': '0' });
            $('.classfiy_pop').css({ 'background-color': 'rgba(0, 0, 0, 0.3)', 'position': 'fixed', 'top': '0', 'left': '0', 'z-index': '100', 'width': '100%', 'height': '100%', 'display': 'none' });
            $('.classfiy_pop .mask').css({ 'z-index': '101', 'position': 'fixed', 'top': '0', 'left': '0', 'width': '100%', 'height': '100%' });
            $('.classfiy_nav').css({ 'position': 'fixed', 'right': '0', 'top': '40px', 'background': '#fff', 'border-radius': ' 0 0 0 5px', 'z-index': '102' });
            $('.classfiy_nav li').css({ 'height': '40px', 'line-height': '40px', 'border-bottom': '1px solid #ccc', 'width': '110px' });
            $('.classfiy_nav li:last-child').css({ 'border-bottom': 'none', 'border-radius': '0 0 0 5px' });
            $('.classfiy_nav li a').css({ 'height': '40px', 'line-height': '40px', 'display': 'block', 'box-sizing': 'border-box', 'width': '100%', 'color': '#333', 'padding': '0 0 0 10px', 'border-left': '2px solid #fff', 'font-size': '16px' });
            $('.classfiy_nav li b').css({ 'width': '22px', 'height': '24px', 'background': 'url(//i0.ulecdn.com/ulewap/i/classfiyNav_icon.png) -9999px -9999px no-repeat', 'background-size': '91px 46px', 'margin': '0 5px 0 0', 'display': 'inline-block', 'vertical-align': 'middle' });
            $('.classfiy_nav li.homeLi b').css({ 'background-position': '0 1px', 'background-size': '91px 46px' });
            $('.classfiy_nav li.classfiyLi b').css({ 'background-position': '-24px 1px', 'background-size': '91px 46px' });
            $('.classfiy_nav li.cartLi b').css({ 'background-position': '-48px 1px', 'background-size': '91px 46px' });
            $('.classfiy_nav li.my_centerLi b').css({ 'background-position': '-72px 1px', 'background-size': '91px 46px' });
            $('.classfiy_nav .homeLi.current b').css({ 'background-position': '0 -23px', 'background-size': '91px 46px' });
            $('.classfiy_nav .classfiyLi.current b').css({ 'background-position': '-24px -23px', 'background-size': '91px 46px' });
            $('.classfiy_nav .cartLi.current b').css({ 'background-position': '-48px -23px', 'background-size': '91px 46px' });
            $('.classfiy_nav .my_centerLi.current b').css({ 'background-position': '-72px -23px', 'background-size': '91px 46px' });
            $('.classfiy_nav li a:hover').css({ 'text-decoration': 'none', 'color': '#333' });
            $('.classfiy_nav li.current a').css({ 'border-left': '2px solid #f52626', 'color': '#f52626' });
            if ($.browser.ule) {
                if ($.browser.ios) {
                    if (parseInt($.browser.version) > 367) {
                        $(".headTitle").css({ "padding-top": "20px" });
                        $(".headTitle a.back").css({ "top": "32px" });
                        $(".headTitle a.classfiy").css({ "top": "20px" })
                    }
                }
            }
        },
        getParams: function() {
            var data = {};
            var href = location.href;
            var paramStr = href.substring(href.indexOf("?") + 1);
            var paramArr = paramStr.split("&");
            for (var i = 0; i < paramArr.length; i++) {
                var item = paramArr[i];
                var keyVal = item.split("=");
                var val = item.slice(item.indexOf("=") + 1);
                data[keyVal[0]] = val
            }
            return data
        },
        backup: function() {
            var backHtml = '';
            backHtml = '<div class="fixed_btn"><a class="go_back"></a></div>';
            $('body').append(backHtml);
            $(".fixed_btn").css({ "position": "fixed", "right": "10px", "bottom": "-300px", "z-index": "20" });
            $('.fixed_btn a.go_back').css({ "width": "48px", "height": "48px", "display": "block", "background": "url(//i0.ulecdn.com/ulewap/i/fixed_button2.png) 0 0 no-repeat", "background-size": "100%", "position": "relative" });
            $('.fixed_btn a.go_back').click(function() {
                $('html, body').scrollTop(0);
                event.preventDefault()
            });
            $(window).scroll(function() { var scroolh = $('body').scrollTop() || $('html').scrollTop() || $(document).scrollTop || $(window).scrollTop(); if (scroolh > 200) { $(".fixed_btn").css({ "bottom": "10%" }) } else { $(".fixed_btn").css({ "bottom": "-300px", "transition": "all ease 1.2s", "-webkit-transition": "all ease 1.2s", "-moz-transition": "all ease 1.2s", "-ms-transition": "all ease 1.2s", "-o-transition": "all ease 1.2s" }) } })
        },
        skipApp: function() { var headTitle = document.title; var pageUrl = location.href.sliceAfter('com'); var myUrl = pageUrl.replace(/skipApp=true&?|&?skipApp=true/, ''); var uleUrl = location.host.substring(location.host.indexOf('.') + 1); if ($.browser.ios) { location.href = encodeURI('ulebuy://WEBVIEW%%%hideNavgationBar^^^0///title^^^' + headTitle + '///key^^^https://' + uleUrl + myUrl + '///hasxib^^^0') } else if ($.browser.android) { location.href = encodeURI('ulebuy://ProductActivity&&wgt.ProductDetail&&url::https://' + uleUrl + myUrl + '##title::' + headTitle) } }
    }))
}(Zepto),
function(a) {
    if (a && window.JEND) {
        var b = a('script:last').attr('src').sliceBefore('/j/'),
            c = 'j/';
        JEND.load.version = '181113', JEND.load.setPath(b + '/'), JEND.loader.scriptPath = b + '/j/', JEND.load.add('touchslide', { js: c + 'yl/touchslide.js' }), JEND.load.add('swiperplugin', { js: c + 'yl/swiper.min.js', css: c + 'yl/swiper.css' }), JEND.load.add('groupbuy', { js: c + 'yl/groupbuy_v2.js', css: c + 'yl/groupbuy.css' }), JEND.load.add('skill', { js: c + 'yl/skill_v2.js', css: c + 'yl/skill_v2.css' }), JEND.load.add('lazyload', { js: c + 'yl/lazyload.js' }), JEND.load.add('wxshare', { js: c + 'yl/wxshare.js' })
    }
}(Zepto);


// WEBPACK FOOTER //
// ./src/assets/js/zepto_yl.min.js